/*!
 * Light.js v0.1.107
 * (c) 2016 Nicolas Riciotti
 * Released under the MIT License.
 */
(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    (global.light = factory());
}(this, function () { 'use strict';

    var babelHelpers = {};

    babelHelpers.classCallCheck = function (instance, Constructor) {
      if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
      }
    };

    babelHelpers.inherits = function (subClass, superClass) {
      if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
      }

      subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
          value: subClass,
          enumerable: false,
          writable: true,
          configurable: true
        }
      });
      if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
    };

    babelHelpers.possibleConstructorReturn = function (self, call) {
      if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      }

      return call && (typeof call === "object" || typeof call === "function") ? call : self;
    };

    babelHelpers;

    /*!
    Copyright (C) 2014-2015 by WebReflection

    Permission is hereby granted, free of charge, to any person obtaining a copy
    of this software and associated documentation files (the "Software"), to deal
    in the Software without restriction, including without limitation the rights
    to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
    copies of the Software, and to permit persons to whom the Software is
    furnished to do so, subject to the following conditions:

    The above copyright notice and this permission notice shall be included in
    all copies or substantial portions of the Software.

    THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
    IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
    FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
    AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
    LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
    OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
    THE SOFTWARE.
    */

    (function (window, document, Object, REGISTER_ELEMENT) {

      'use strict';

      // in case it's there or already patched

      if (REGISTER_ELEMENT in document) return;

      // DO NOT USE THIS FILE DIRECTLY, IT WON'T WORK
      // THIS IS A PROJECT BASED ON A BUILD SYSTEM
      // THIS FILE IS JUST WRAPPED UP RESULTING IN
      // build/document-register-element.js
      // and its .max.js counter part

      // IE < 11 only + old WebKit for attributes + feature detection
      var EXPANDO_UID = '__' + REGISTER_ELEMENT + (Math.random() * 10e4 >> 0),


      // shortcuts and costants
      ATTACHED = 'attached',
          DETACHED = 'detached',
          EXTENDS = 'extends',
          ADDITION = 'ADDITION',
          MODIFICATION = 'MODIFICATION',
          REMOVAL = 'REMOVAL',
          DOM_ATTR_MODIFIED = 'DOMAttrModified',
          DOM_CONTENT_LOADED = 'DOMContentLoaded',
          DOM_SUBTREE_MODIFIED = 'DOMSubtreeModified',
          PREFIX_TAG = '<',
          PREFIX_IS = '=',


      // valid and invalid node names
      validName = /^[A-Z][A-Z0-9]*(?:-[A-Z0-9]+)+$/,
          invalidNames = ['ANNOTATION-XML', 'COLOR-PROFILE', 'FONT-FACE', 'FONT-FACE-SRC', 'FONT-FACE-URI', 'FONT-FACE-FORMAT', 'FONT-FACE-NAME', 'MISSING-GLYPH'],


      // registered types and their prototypes
      types = [],
          protos = [],


      // to query subnodes
      query = '',


      // html shortcut used to feature detect
      documentElement = document.documentElement,


      // ES5 inline helpers || basic patches
      indexOf = types.indexOf || function (v) {
        for (var i = this.length; i-- && this[i] !== v;) {}
        return i;
      },


      // other helpers / shortcuts
      OP = Object.prototype,
          hOP = OP.hasOwnProperty,
          iPO = OP.isPrototypeOf,
          defineProperty = Object.defineProperty,
          gOPD = Object.getOwnPropertyDescriptor,
          gOPN = Object.getOwnPropertyNames,
          gPO = Object.getPrototypeOf,
          sPO = Object.setPrototypeOf,


      // jshint proto: true
      hasProto = !!Object.__proto__,


      // used to create unique instances
      create = Object.create || function Bridge(proto) {
        // silly broken polyfill probably ever used but short enough to work
        return proto ? (Bridge.prototype = proto, new Bridge()) : this;
      },


      // will set the prototype if possible
      // or copy over all properties
      setPrototype = sPO || (hasProto ? function (o, p) {
        o.__proto__ = p;
        return o;
      } : gOPN && gOPD ? function () {
        function setProperties(o, p) {
          for (var key, names = gOPN(p), i = 0, length = names.length; i < length; i++) {
            key = names[i];
            if (!hOP.call(o, key)) {
              defineProperty(o, key, gOPD(p, key));
            }
          }
        }
        return function (o, p) {
          do {
            setProperties(o, p);
          } while ((p = gPO(p)) && !iPO.call(p, o));
          return o;
        };
      }() : function (o, p) {
        for (var key in p) {
          o[key] = p[key];
        }
        return o;
      }),


      // DOM shortcuts and helpers, if any

      MutationObserver = window.MutationObserver || window.WebKitMutationObserver,
          HTMLElementPrototype = (window.HTMLElement || window.Element || window.Node).prototype,
          IE8 = !iPO.call(HTMLElementPrototype, documentElement),
          isValidNode = IE8 ? function (node) {
        return node.nodeType === 1;
      } : function (node) {
        return iPO.call(HTMLElementPrototype, node);
      },
          targets = IE8 && [],
          cloneNode = HTMLElementPrototype.cloneNode,
          importNode = document.importNode,
          setAttribute = HTMLElementPrototype.setAttribute,
          removeAttribute = HTMLElementPrototype.removeAttribute,


      // replaced later on
      createElement = document.createElement,


      // shared observer for all attributes
      attributesObserver = MutationObserver && {
        attributes: true,
        characterData: true,
        attributeOldValue: true
      },


      // useful to detect only if there's no MutationObserver
      DOMAttrModified = MutationObserver || function (e) {
        doesNotSupportDOMAttrModified = false;
        documentElement.removeEventListener(DOM_ATTR_MODIFIED, DOMAttrModified);
      },


      // will both be used to make DOMNodeInserted asynchronous
      asapQueue,
          rAF = window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.msRequestAnimationFrame || function (fn) {
        setTimeout(fn, 10);
      },


      // internal flags
      setListener = false,
          doesNotSupportDOMAttrModified = true,
          dropDomContentLoaded = true,


      // needed for the innerHTML helper
      notFromInnerHTMLHelper = true,


      // optionally defined later on
      onSubtreeModified,
          callDOMAttrModified,
          getAttributesMirror,
          observer,


      // based on setting prototype capability
      // will check proto or the expando attribute
      // in order to setup the node once
      patchIfNotAlready,
          patch;

      if (sPO || hasProto) {
        patchIfNotAlready = function (node, proto) {
          if (!iPO.call(proto, node)) {
            setupNode(node, proto);
          }
        };
        patch = setupNode;
      } else {
        patchIfNotAlready = function (node, proto) {
          if (!node[EXPANDO_UID]) {
            node[EXPANDO_UID] = Object(true);
            setupNode(node, proto);
          }
        };
        patch = patchIfNotAlready;
      }
      if (IE8) {
        doesNotSupportDOMAttrModified = false;
        (function () {
          var descriptor = gOPD(HTMLElementPrototype, 'addEventListener'),
              addEventListener = descriptor.value,
              patchedRemoveAttribute = function (name) {
            var e = new CustomEvent(DOM_ATTR_MODIFIED, { bubbles: true });
            e.attrName = name;
            e.prevValue = this.getAttribute(name);
            e.newValue = null;
            e[REMOVAL] = e.attrChange = 2;
            removeAttribute.call(this, name);
            this.dispatchEvent(e);
          },
              patchedSetAttribute = function (name, value) {
            var had = this.hasAttribute(name),
                old = had && this.getAttribute(name),
                e = new CustomEvent(DOM_ATTR_MODIFIED, { bubbles: true });

            setAttribute.call(this, name, value);
            e.attrName = name;
            e.prevValue = had ? old : null;
            e.newValue = value;
            if (had) {
              e[MODIFICATION] = e.attrChange = 1;
            } else {
              e[ADDITION] = e.attrChange = 0;
            }
            this.dispatchEvent(e);
          },
              onPropertyChange = function (e) {
            // jshint eqnull:true
            var node = e.currentTarget,
                superSecret = node[EXPANDO_UID],
                propertyName = e.propertyName,
                event;
            if (superSecret.hasOwnProperty(propertyName)) {
              superSecret = superSecret[propertyName];
              event = new CustomEvent(DOM_ATTR_MODIFIED, { bubbles: true });
              event.attrName = superSecret.name;
              event.prevValue = superSecret.value || null;
              event.newValue = superSecret.value = node[propertyName] || null;
              if (event.prevValue == null) {
                event[ADDITION] = event.attrChange = 0;
              } else {
                event[MODIFICATION] = event.attrChange = 1;
              }
              node.dispatchEvent(event);
            }
          };
          descriptor.value = function (type, handler, capture) {
            if (type === DOM_ATTR_MODIFIED && this.attributeChangedCallback && this.setAttribute !== patchedSetAttribute) {
              this[EXPANDO_UID] = {
                className: {
                  name: 'class',
                  value: this.className
                }
              };
              this.setAttribute = patchedSetAttribute;
              this.removeAttribute = patchedRemoveAttribute;
              addEventListener.call(this, 'propertychange', onPropertyChange);
            }
            addEventListener.call(this, type, handler, capture);
          };
          defineProperty(HTMLElementPrototype, 'addEventListener', descriptor);
        })();
      } else if (!MutationObserver) {
        documentElement.addEventListener(DOM_ATTR_MODIFIED, DOMAttrModified);
        documentElement.setAttribute(EXPANDO_UID, 1);
        documentElement.removeAttribute(EXPANDO_UID);
        if (doesNotSupportDOMAttrModified) {
          onSubtreeModified = function (e) {
            var node = this,
                oldAttributes,
                newAttributes,
                key;
            if (node === e.target) {
              oldAttributes = node[EXPANDO_UID];
              node[EXPANDO_UID] = newAttributes = getAttributesMirror(node);
              for (key in newAttributes) {
                if (!(key in oldAttributes)) {
                  // attribute was added
                  return callDOMAttrModified(0, node, key, oldAttributes[key], newAttributes[key], ADDITION);
                } else if (newAttributes[key] !== oldAttributes[key]) {
                  // attribute was changed
                  return callDOMAttrModified(1, node, key, oldAttributes[key], newAttributes[key], MODIFICATION);
                }
              }
              // checking if it has been removed
              for (key in oldAttributes) {
                if (!(key in newAttributes)) {
                  // attribute removed
                  return callDOMAttrModified(2, node, key, oldAttributes[key], newAttributes[key], REMOVAL);
                }
              }
            }
          };
          callDOMAttrModified = function (attrChange, currentTarget, attrName, prevValue, newValue, action) {
            var e = {
              attrChange: attrChange,
              currentTarget: currentTarget,
              attrName: attrName,
              prevValue: prevValue,
              newValue: newValue
            };
            e[action] = attrChange;
            onDOMAttrModified(e);
          };
          getAttributesMirror = function (node) {
            for (var attr, name, result = {}, attributes = node.attributes, i = 0, length = attributes.length; i < length; i++) {
              attr = attributes[i];
              name = attr.name;
              if (name !== 'setAttribute') {
                result[name] = attr.value;
              }
            }
            return result;
          };
        }
      }

      function loopAndVerify(list, action) {
        for (var i = 0, length = list.length; i < length; i++) {
          verifyAndSetupAndAction(list[i], action);
        }
      }

      function loopAndSetup(list) {
        for (var i = 0, length = list.length, node; i < length; i++) {
          node = list[i];
          patch(node, protos[getTypeIndex(node)]);
        }
      }

      function executeAction(action) {
        return function (node) {
          if (isValidNode(node)) {
            verifyAndSetupAndAction(node, action);
            loopAndVerify(node.querySelectorAll(query), action);
          }
        };
      }

      function getTypeIndex(target) {
        var is = target.getAttribute('is'),
            nodeName = target.nodeName.toUpperCase(),
            i = indexOf.call(types, is ? PREFIX_IS + is.toUpperCase() : PREFIX_TAG + nodeName);
        return is && -1 < i && !isInQSA(nodeName, is) ? -1 : i;
      }

      function isInQSA(name, type) {
        return -1 < query.indexOf(name + '[is="' + type + '"]');
      }

      function onDOMAttrModified(e) {
        var node = e.currentTarget,
            attrChange = e.attrChange,
            attrName = e.attrName,
            target = e.target;
        if (notFromInnerHTMLHelper && (!target || target === node) && node.attributeChangedCallback && attrName !== 'style' & e.prevValue !== e.newValue) {
          node.attributeChangedCallback(attrName, attrChange === e[ADDITION] ? null : e.prevValue, attrChange === e[REMOVAL] ? null : e.newValue);
        }
      }

      function onDOMNode(action) {
        var executor = executeAction(action);
        return function (e) {
          asapQueue.push(executor, e.target);
        };
      }

      function onReadyStateChange(e) {
        if (dropDomContentLoaded) {
          dropDomContentLoaded = false;
          e.currentTarget.removeEventListener(DOM_CONTENT_LOADED, onReadyStateChange);
        }
        loopAndVerify((e.target || document).querySelectorAll(query), e.detail === DETACHED ? DETACHED : ATTACHED);
        if (IE8) purge();
      }

      function patchedSetAttribute(name, value) {
        // jshint validthis:true
        var self = this;
        setAttribute.call(self, name, value);
        onSubtreeModified.call(self, { target: self });
      }

      function setupNode(node, proto) {
        setPrototype(node, proto);
        if (observer) {
          observer.observe(node, attributesObserver);
        } else {
          if (doesNotSupportDOMAttrModified) {
            node.setAttribute = patchedSetAttribute;
            node[EXPANDO_UID] = getAttributesMirror(node);
            node.addEventListener(DOM_SUBTREE_MODIFIED, onSubtreeModified);
          }
          node.addEventListener(DOM_ATTR_MODIFIED, onDOMAttrModified);
        }
        if (node.createdCallback && notFromInnerHTMLHelper) {
          // node._isCreated = true;
          node.createdCallback();
          //node._isCreated = false;
        }
      }

      function purge() {
        for (var node, i = 0, length = targets.length; i < length; i++) {
          node = targets[i];
          if (!documentElement.contains(node)) {
            length--;
            targets.splice(i--, 1);
            verifyAndSetupAndAction(node, DETACHED);
          }
        }
      }

      function throwTypeError(type) {
        throw new Error('A ' + type + ' type is already registered');
      }

      function verifyAndSetupAndAction(node, action) {
        var fn,
            i = getTypeIndex(node);
        if (-1 < i) {
          patchIfNotAlready(node, protos[i]);
          i = 0;
          if (action === ATTACHED && !node['_is' + ATTACHED]) {
            node['_is' + DETACHED] = false;
            node['_is' + ATTACHED] = true;
            i = 1;
            if (IE8 && indexOf.call(targets, node) < 0) {
              targets.push(node);
            }
          } else if (action === DETACHED && !node['_is' + DETACHED]) {
            node['_is' + ATTACHED] = false;
            node['_is' + DETACHED] = true;
            i = 1;
          }
          if (i && (fn = node[action + 'Callback'])) fn.call(node);
        }
      }

      // set as enumerable, writable and configurable
      document[REGISTER_ELEMENT] = function registerElement(type, options) {

        upperType = type.toUpperCase();

        if (!setListener) {

          console.log('__SET LISTENER__');

          // only first time document.registerElement is used
          // we need to set this listener
          // setting it by default might slow down for no reason
          setListener = true;
          if (MutationObserver) {

            observer = function (attached, detached) {

              function checkEmAll(list, callback) {
                for (var i = 0, length = list.length; i < length; callback(list[i++])) {}
              }

              return new MutationObserver(function (records) {

                for (var current, node, newValue, i = 0, length = records.length; i < length; i++) {

                  current = records[i];
                  if (current.type === 'childList') {
                    checkEmAll(current.addedNodes, attached);
                    checkEmAll(current.removedNodes, detached);
                  } else {
                    node = current.target;
                    if (notFromInnerHTMLHelper && node.attributeChangedCallback && current.attributeName !== 'style') {
                      newValue = node.getAttribute(current.attributeName);
                      if (newValue !== current.oldValue) {
                        node.attributeChangedCallback(current.attributeName, current.oldValue, newValue);
                      }
                    }
                  }
                }
              });
            }(executeAction(ATTACHED), executeAction(DETACHED));

            observer.observe(document, {
              childList: true,
              subtree: true
            });

            // var attachedCallback = executeAction(ATTACHED);
            // var detachedCallback = executeAction(DETACHED);

            // document.addEventListener('DOMNodeInserted', function(e){
            //   attachedCallback(e.target);
            // });

            // document.addEventListener('DOMNodeRemoved', function(e){
            //   detachedCallback(e.target);
            // });
          } else {
              asapQueue = [];
              rAF(function ASAP() {
                while (asapQueue.length) {
                  asapQueue.shift().call(null, asapQueue.shift());
                }
                rAF(ASAP);
              });
              document.addEventListener('DOMNodeInserted', onDOMNode(ATTACHED));
              document.addEventListener('DOMNodeRemoved', onDOMNode(DETACHED));
            }

          document.addEventListener(DOM_CONTENT_LOADED, onReadyStateChange);
          document.addEventListener('readystatechange', onReadyStateChange);

          document.importNode = function (nd, deep) {
            var node = importNode.call(document, nd, !!deep);

            if (node.attributes) {
              var i = getTypeIndex(node);
              if (-1 < i) patch(node, protos[i]);
              if (deep) loopAndSetup(node.querySelectorAll(query));
            }
            return node;
          };

          document.createElement = function (localName, typeExtension) {

            var node = createElement.apply(document, arguments),
                name = '' + localName,
                i = indexOf.call(types, (typeExtension ? PREFIX_IS : PREFIX_TAG) + (typeExtension || name).toUpperCase()),
                setup = -1 < i;
            if (typeExtension) {
              node.setAttribute('is', typeExtension = typeExtension.toLowerCase());
              if (setup) {
                setup = isInQSA(name.toUpperCase(), typeExtension);
              }
            }
            notFromInnerHTMLHelper = !document.createElement.innerHTMLHelper;
            if (setup) patch(node, protos[i]);
            return node;
          };

          HTMLElementPrototype.cloneNode = function (deep) {
            var node = cloneNode.call(this, !!deep),
                i = getTypeIndex(node);
            if (-1 < i) patch(node, protos[i]);
            if (deep) loopAndSetup(node.querySelectorAll(query));
            return node;
          };
        }

        if (-2 < indexOf.call(types, PREFIX_IS + upperType) + indexOf.call(types, PREFIX_TAG + upperType)) {
          throwTypeError(type);
        }

        if (!validName.test(upperType) || -1 < indexOf.call(invalidNames, upperType)) {
          throw new Error('The type ' + type + ' is invalid');
        }

        var constructor = function () {
          return extending ? document.createElement(nodeName, upperType) : document.createElement(nodeName);
        },
            opt = options || OP,
            extending = hOP.call(opt, EXTENDS),
            nodeName = extending ? options[EXTENDS].toUpperCase() : upperType,
            upperType,
            i;

        if (extending && -1 < indexOf.call(types, PREFIX_TAG + nodeName)) {
          throwTypeError(nodeName);
        }

        i = types.push((extending ? PREFIX_IS : PREFIX_TAG) + upperType) - 1;

        query = query.concat(query.length ? ',' : '', extending ? nodeName + '[is="' + type.toLowerCase() + '"]' : nodeName);

        constructor.prototype = protos[i] = hOP.call(opt, 'prototype') ? opt.prototype : create(HTMLElementPrototype);

        loopAndVerify(document.querySelectorAll(query), ATTACHED);

        return constructor;
      };
    })(window, document, Object, 'registerElement');

    if (!Array.prototype.includes) {
      Array.prototype.includes = function (searchElement /*, fromIndex*/) {
        'use strict';

        var O = Object(this);
        var len = parseInt(O.length) || 0;
        if (len === 0) {
          return false;
        }
        var n = parseInt(arguments[1]) || 0;
        var k;
        if (n >= 0) {
          k = n;
        } else {
          k = len + n;
          if (k < 0) {
            k = 0;
          }
        }
        var currentElement;
        while (k < len) {
          currentElement = O[k];
          if (searchElement === currentElement || searchElement !== searchElement && currentElement !== currentElement) {
            // NaN !== NaN
            return true;
          }
          k++;
        }
        return false;
      };
    }

    /** RequestAnimationFrame browser compatibility */
    (function () {

      var lastTime = 0,
          x = 0,
          vendors = ['ms', 'moz', 'webkit', 'o'];

      for (; x < vendors.length && !window.requestAnimationFrame; ++x) {
        window.requestAnimationFrame = window[vendors[x] + 'RequestAnimationFrame'];
        window.cancelAnimationFrame = window[vendors[x] + 'CancelAnimationFrame'] || window[vendors[x] + 'CancelRequestAnimationFrame'];
      }

      if (window.msRequestAnimationFrame) {
        window.requestAnimationFrame = function (callback) {
          return window.msRequestAnimationFrame(function () {
            callback(+new Date());
          });
        };
      }

      if (!window.requestAnimationFrame) window.requestAnimationFrame = function (callback, element) {
        var currTime = Date.now();
        var timeToCall = 1000 / 60; //Math.max(0, 16 - (currTime - lastTime));
        var id = window.setTimeout(function () {
          callback(currTime + timeToCall);
        }, timeToCall);
        lastTime = currTime + timeToCall;
        return id;
      };

      if (!window.cancelAnimationFrame) window.cancelAnimationFrame = function (id) {
        clearTimeout(id);
      };
    })();

    function camelCalise$1(string) {
      return string.replace(/-([a-zA-Z0-9])/g, function (g) {
        return g[1].toUpperCase();
      });
    }

    function pascalise$1(string) {
      var str = camelCalise$1(string);
      return str.charAt(0).toUpperCase() + str.slice(1);
    }

    function hyphenise$1(string) {
      return string.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();;
    }

    function isArray$1(object) {
      return Object.prototype.toString.call(object) === '[object Array]' || Object.prototype.toString.call(object) === '[object NodeList]';
    }

    function isObject$1(object) {
      return Object.prototype.toString.call(object) === '[object Object]';
    }

    function extend$1() {

        var options,
            k,
            baseObject = arguments[0] || {},
            i = 1,
            length = arguments.length;

        if (typeof baseObject !== "object" && typeof baseObject !== 'function') baseObject = {};

        for (; i < length; i++) {
            if ((options = arguments[i]) != null) {
                for (k in options) {
                    if (options[k] !== undefined) {
                        baseObject[k] = options[k];
                    }
                }
            }
        }

        return baseObject;
    };

    function clone$1(obj) {
      return isArray$1(obj) ? obj.slice() : extend$1({}, obj);
    }

    function cloneDeep$1(obj) {

    	var newObj;

    	if (isArray$1(obj)) {
    		newObj = [];
    		for (var i = 0, l = obj.length; i < l; i++) {
    			newObj.push(typeof obj[i] === "object" && obj[i] !== null ? cloneDeep$1(obj[i]) : obj[i]);
    		}
    	} else {
    		newObj = {};
    		for (var k in obj) {
    			newObj[k] = typeof obj[k] === "object" && obj[k] !== null ? cloneDeep$1(obj[k]) : obj[k];
    		}
    	}

    	return newObj;
    }

    var _nob = {};

    function nop$1() {};

    var support$1 = {};
    var tests = null;
    var testDiv = document.createElement('div');
    var testDivStyle = testDiv.style;
    var prefixes = ' Webkit WebKit Moz O Ms'.split(' ');
    var cssprefixes = ' -webkit- -webkit- -moz- -o- -ms-'.split(' ');
    var prefixesLength = prefixes.length;
    var useCache = false;
    var testProperty = function (prop, cssformat) {

      if (useCache & prop in support$1) {
        return support$1[prop];
      }

      var formatForCss = typeof cssformat != "undefined" ? cssformat : false,
          propd,
          l = prefixesLength;

      propd = prop.replace(/(^[a-z])/g, function (val) {
        return val.toUpperCase();
      }).replace(/\-([a-z])/g, function (val, a) {
        return a.toUpperCase();
      });

      while (l--) {
        if (prop in testDivStyle) {
          return prop;
        } else if (prefixes[l] + propd in testDivStyle) {
          return formatForCss ? cssprefixes[l] + prop.toLowerCase() : prefixes[l] + propd;
        } else if (typeof window[prefixes[l].toLowerCase() + propd] !== 'undefined') {
          return prefixes[l].toLowerCase() + propd;
        } else if (typeof window[prefixes[l] + propd] != 'undefined') {
          return prefixes[l] + propd;
        }
      }

      return false;
    };
    tests = {

      prefix: function () {
        var prefixedProp = testProperty('transform');
        return !!prefixedProp ? prefixedProp.replace('Transform', '') : '';
      },

      cssprefix: function () {
        var prefixedProp = testProperty('transform', true);
        return !!prefixedProp ? prefixedProp.replace('transform', '') : '';
      },

      transform: function () {
        return testProperty('transform');
      },

      transformCss: function () {
        return testProperty('transform', true);
      },

      transform3d: function () {
        return 'WebKitCSSMatrix' in window && 'm11' in new WebKitCSSMatrix() || !!testProperty('perspective');
      },

      translateZ: function () {
        return this.transform3d() ? 'translateZ(0)' : '';
      },

      transformOrigin: function () {
        return testProperty('transformOrigin');
      },

      backfaceVisibility: function () {
        return testProperty('backfaceVisibility');
      },

      perspective: function () {
        return testProperty('perspective');
      },

      perspectiveOrigin: function () {
        return testProperty('perspectiveOrigin');
      },

      transition: function () {
        return testProperty('transition');
      },

      transitionProperty: function () {
        return testProperty('transitionProperty');
      },

      transitionDuration: function () {
        return testProperty('transitionDuration');
      },

      transitionTimingFunction: function () {
        return testProperty('transitionTimingFunction');
      },

      transitionDelay: function () {
        return testProperty('transitionDelay');
      },

      transitionEvent: function () {
        return testProperty('transitionEvent');
      },

      transitionEventPrefix: function () {
        return !!testProperty('transitionEvent') ? testProperty('transitionEvent').replace('TransitionEvent', '').toLowerCase() : '';
      },

      transitionEnd: function () {
        return this.transitionEventPrefix() !== '' ? this.transitionEventPrefix() + 'TransitionEnd' : 'transitionend';
      },

      touch: function () {
        return 'ontouchstart' in window || /*|| (navigator.maxTouchPoints > 0)*/navigator.msMaxTouchPoints > 0;
      },

      //IE10 Pointers
      msPointer: function () {
        return !!window.navigator.msPointerEnabled;
      },

      //IE11 Pointers
      pointer: function () {
        return !!window.navigator.pointerEnabled;
      },

      ipad: function () {
        return navigator.userAgent.match(/.*(iPad).*/) ? true : false;
      },
      iphone: function () {
        return navigator.userAgent.match(/.*(iPhone).*/) ? true : false;
      },
      android: function () {
        return navigator.userAgent.match(/.*(Android).*/) ? true : false;
      },
      firefox: function () {
        return navigator.userAgent.match(/.*((f|F)irefox).*/) ? true : false;
      },

      /** browser */
      ltIE9: function () {
        return window.attachEvent && !window.addEventListener;
      },

      pointerdown: function () {
        return this.touch() ? 'touchstart' : this.pointer() ? 'pointerdown' : this.msPointer() ? 'MSPointerDown' : 'mousedown';
      },
      pointerup: function () {
        return this.touch() ? 'touchend' : this.pointer() ? 'pointerup' : this.msPointer() ? 'MSPointerUp' : 'mouseup';
      },
      pointermove: function () {
        return this.touch() ? 'touchmove' : this.pointer() ? 'pointermove' : this.msPointer() ? 'MSPointerMove' : 'mousemove';
      },
      pointerenter: function () {
        return this.touch() ? 'touchstart' : this.pointer() ? 'pointerenter' : this.msPointer() ? 'MSPointerEnter' : 'mouseenter';
      },
      pointerleave: function () {
        return this.touch() ? 'touchend' : this.pointer() ? 'pointerleave' : this.msPointer() ? 'MSPointerLeave' : 'mouseleave';
      },
      pointerover: function () {
        return this.touch() ? 'touchstart' : this.pointer() ? 'pointerover' : this.msPointer() ? 'MSPointerOver' : 'mouseover';
      },
      pointerout: function () {
        return this.touch() ? 'touchend' : this.pointer() ? 'pointerout' : this.msPointer() ? 'MSPointerOut' : 'mouseout';
      },

      //use multi prefix for older version of light compatibility
      multipointerdown: function () {
        return this.touch() ? 'onmousedown' in window && !this.ipad() && !this.iphone() ? ['mousedown', 'touchstart'] : ['touchstart'] : this.pointer() ? ['pointerdown'] : this.msPointer() ? ['MSPointerDown'] : ['mousedown'];
      },
      multipointerup: function () {
        return this.touch() ? 'onmousedown' in window && !this.ipad() && !this.iphone() ? ['mouseup', 'touchend'] : ['touchend'] : this.pointer() ? ['pointerup'] : this.msPointer() ? ['MSPointerUp'] : ['mouseup'];
      },
      multipointermove: function () {
        return this.touch() ? 'onmousedown' in window && !this.ipad() && !this.iphone() ? ['mousemove', 'touchmove'] : ['touchmove'] : this.pointer() ? ['pointermove'] : this.msPointer() ? ['MSPointerMove'] : ['mousemove'];
      },
      multipointerenter: function () {
        return this.touch() ? 'onmousedown' in window && !this.ipad() && !this.iphone() ? ['mouseenter', 'touchstart'] : ['touchstart'] : this.pointer() ? ['pointerenter'] : this.msPointer() ? ['MSPointerEnter'] : ['mouseenter'];
      },
      multipointerleave: function () {
        return this.touch() ? 'onmousedown' in window && !this.ipad() && !this.iphone() ? ['mouseleave', 'touchend'] : ['touchend'] : this.pointer() ? ['pointerleave'] : this.msPointer() ? ['MSPointerLeave'] : ['mouseleave'];
      },
      multipointerover: function () {
        return this.touch() ? 'onmousedown' in window && !this.ipad() && !this.iphone() ? ['mouseover', 'touchstart'] : ['touchstart'] : this.pointer() ? ['pointerover'] : this.msPointer() ? ['MSPointerOver'] : ['mouseover'];
      },
      multipointerout: function () {
        return this.touch() ? 'onmousedown' in window && !this.ipad() && !this.iphone() ? ['mouseout', 'touchend'] : ['touchend'] : this.pointer() ? ['pointerout'] : this.msPointer() ? ['MSPointerOut'] : ['mouseout'];
      },

      smallscreen: function () {
        return window.innerWidth < 700;
      }

    };

    var featureName;
    for (var feature in tests) {
      if (tests.hasOwnProperty(feature)) {
        featureName = feature;
        support$1[featureName] = tests[feature]();
      }
    }

    /**
     * check if the given property exists in div.style or window
     * and returns a boolean
     *
     * @param {string} prop Name of the property to check
     * @return {Boolean} true, or if not found, false.
     */
    support$1['test'] = function (prop) {
      return !!testProperty(prop);
    };

    /**
     * check if the given property exists in div.style or window and
     * returns it with the vendor prefixe
     *
     * @param {string} prop Name of the property to check
     * @return {String|Boolean} prefix + prop, or if not found, false.
     */
    support$1['getPrefixed'] = function (prop) {
      return testProperty(prop);
    };

    /**
     * same as getPrefixed but it returns the css perfixed version
     *
     * @param {string} prop Name of the property to check
     * @return {String|Boolean} prefix + prop, or if not found, false.
     */
    support$1['getCssPrefixed'] = function (prop) {
      return testProperty(prop, true);
    };

    var vendors = ["moz", "webkit", "", "ms", "o"];
    var l = vendors.length;
    if (document.cancelFullscreen !== undefined) {
      support$1.requestFullscreen = "requestFullscreen";
      support$1.cancelFullScreen = "exitFullscreen";
      support$1.fullscreenchange = "fullscreenchange";
    } else {
      while (l--) {
        if ((vendors[l] != "moz" || document.mozFullScreenEnabled) && document[vendors[l] + "CancelFullScreen"] !== undefined) {
          support$1.requestFullscreen = vendors[l] + "RequestFullScreen";
          support$1.cancelFullScreen = vendors[l] + "CancelFullScreen";
          support$1.fullScreenChange = vendors[l] + "fullscreenchange";
          support$1.isFullScreen = vendors[l] == "webkit" ? vendors[l] + "IsFullScreen" : vendors[l] + "FullScreen";
        }
      }
    }

    useCache = true;

    function setStyle(node, props) {

      props = getTransform(props);

      for (var k in props) {
        var prop = support.getPrefixed(k);
        if (isArray$1(node) || node.length) {
          for (var i = 0, l = node.length; i < l; i++) {
            node[i].style[prop] = props[k];
          }
        } else {
          node.style[prop] = props[k];
        }
      }
    }

    function getTransform(transformPorps) {

      var transform = '';

      for (var p in transformPorps) {

        if ('translateX' == p) {
          transform += 'translateX(' + transformPorps.translateX + ') ';
          delete transformPorps.translateX;
        }

        if ('translateY' == p) {
          transform += 'translateY(' + transformPorps.translateY + ') ';
          delete transformPorps.translateY;
        }

        if ('translate' == p) {
          transform += 'translate(' + transformPorps.translateY + ') ';
          delete transformPorps.translate;
        }

        if ('scale' == p) {
          transform += 'scale(' + transformPorps.scale + ') ';
          delete transformPorps.scale;
        }

        if ('scaleX' == p) {
          transform += 'scaleX(' + transformPorps.scaleX + ') ';
          delete transformPorps.scaleX;
        }

        if ('scaleY' == p) {
          transform += 'scaleY(' + transformPorps.scaleY + ') ';
          delete transformPorps.scaleY;
        }

        if ('rotate' == p) {
          transform += 'rotate(' + transformPorps.rotate + ') ';
          delete transformPorps.rotate;
        }

        if ('force3d' == p) {
          transform += " " + support.translateZ;
        }
      }

      transformPorps.transform = transform;

      return transformPorps;
    }

    function getStyle(node, styleProp) {
      var value;
      if (node.currentStyle) {
        value = node.currentStyle[styleProp];
      } else if (window.getComputedStyle) value = document.defaultView.getComputedStyle(node, null).getPropertyValue(styleProp);
      return value;
    }

    function getPosition(node, scope) {

      var root = scope !== void 0 ? scope : document;
      var offsetTop = node.offsetTop;
      var offsetLeft = node.offsetLeft;

      while (node && node.parentNode && node.parentNode != scope) {
        if (getStyle(node.parentNode, 'position') != 'static') {
          offsetTop += node.parentNode.offsetTop;
          offsetLeft += node.parentNode.offsetLeft;
        }
        node = node.parentNode;
      }

      return {
        top: offsetTop,
        left: offsetLeft
      };
    }

    function notify$1(msg, ctx) {
      console.log("%c" + "[notify]: " + msg, "color:#00aeff", ctx);
    }

    function warn$1(msg, ctx) {
      console.log("%c" + "[warn]: " + msg, "color:#ff0084", ctx);
    }

    var utils = {
    	camelCalise: camelCalise$1,
    	pascalise: pascalise$1,
    	hyphenise: hyphenise$1,
    	isArray: isArray$1,
    	isObject: isObject$1,
    	clone: clone$1,
    	cloneDeep: cloneDeep$1,
    	extend: extend$1,
    	nob: _nob,
    	nop: nop$1,
    	style: setStyle,
    	position: getPosition,
    	notify: notify$1,
    	warn: warn$1
    };

    var isArray = isArray$1;

    var EventDispatcher = {

        /**
         *  normalise event names
         */
        normalize: function (eventName) {
            return eventName.replace(':', '');
        },

        /**
         *  list of events callbacks
         */
        listeners: [],

        on: function (eventName, fn, target) {

            /**
             * We force the bind to diferetiate the class's instance methods:
             * if multiple instances share de same event, when removing the eventdispatcher, it will kill all callback of all instances
             * @type {[type]}
             */
            if (fn === void 0) {
                utils.warn('cannot find callback for ' + eventName + ' in context:' + target);
            } else {
                var eventName = this.normalize(eventName);
                this.listeners.push({ name: eventName, closure: fn, target: target });
            }
        },

        /**
         *  remove callback to a global event chanel
         */
        off: function (eventName, fn, origin) {

            var evt,
                i = 0,
                l = this.listeners.length,
                eventName = this.normalize(eventName);

            for (; i < l; i++) {

                evt = this.listeners[i];

                if (evt.name === eventName && evt.closure === fn && (!origin || evt.target === origin)) {
                    this.listeners.splice(i, 1);
                    i--;
                    l--;
                }
            }
        },

        /**
         *  trigger callbacks from a global event chanel
         */
        fire: function (eventName, params) {

            var evt,
                i = 0,
                l = this.listeners.length,
                eventName = this.normalize(eventName);

            for (; i < l; i++) {
                evt = this.listeners[i];
                if (!evt) continue;
                if (evt.name === eventName) {
                    if (typeof params != "undefined") {
                        evt.closure.apply(evt.target, params);
                    } else {
                        evt.closure.call(evt.target);
                    }
                }
            }
        },

        /**
         *  list of request callbacks
         */
        handlers: {},

        handlersQueue: {},

        /**
         * create global request chanel handler
         */
        setHandler: function (handlerName, handler) {
            handlerName = this.normalize(handlerName);
            this.handlers[handlerName] = handler;
            if (this.handlersQueue[handlerName] !== void 0) {
                for (var i = 0; i < this.handlersQueue[handlerName].length; i++) {
                    this.request(handlerName, this.handlersQueue[handlerName][i]);
                }
                delete this.handlersQueue[handlerName];
            }
        },

        /**
         * trigger global request chanel
         */
        request: function (handlerName, params) {
            handlerName = this.normalize(handlerName);
            if (typeof this.handlers[handlerName] != 'undefined') {
                return typeof params != "undefined" ? this.handlers[handlerName].apply(this, params) : this.handlers[handlerName]();
            } else {
                this.handlersQueue[handlerName] = this.handlersQueue[handlerName] || [];
                this.handlersQueue[handlerName].push(params);
                //return { error: 'request error :: no handler found', handler: handlerName };
            }
        },

        /**
         * COMPATIBILITY
         */
        subscribe: function (eventName, fn, target) {
            _.warn("EventDispatcher.on is depreciated and will be removed. Please use EventDispatcher.on instead");
            this.subscribe(eventName, fn, target);
        },
        unsubscribe: function (eventName, fn) {
            _.warn("EventDispatcher.off is depreciated and will be removed. Please use EventDispatcher.off instead");
            this.off(eventName, fn, target);
        },
        publish: function (eventName, params) {
            _.warn("EventDispatcher.trigger is depreciated and will be removed. Please use EventDispatcher.trigger) instead");
            this.fire(eventName, params);
        },
        trigger: function (eventName, params) {
            _.warn("'EventDispatcher.trigger' is depreciated and will be removed. Please use 'EventDispatcher.fire' instead");
            this.fire(eventName, params);
        }

    };

    var components = {
    	//... store list of registered components
    };

    function register(name, component, extendElementName) {

    	if (typeof components[name] === "undefined") {

    		//var noOverridableMethods = ['_created', '_render', '_rendered', '_resize', '_resized', '_update'];

    		// for(let i=0, l=noOverridableMethods.length; i<l; i++){
    		// 	if (component.prototype.hasOwnProperty( noOverridableMethods[i] )
    		// 		&& name !== "light-core-template"){
    		// 		_.warn( "<"+name+"> Don't use " + noOverridableMethods[i] + "(){} as it may break the component lifecycle " +
    		// 			    "if super." + noOverridableMethods[i] + "() is not called." +
    		// 				" Please use " + noOverridableMethods[i].replace('_','') + "(){} instead" );
    		// 	}
    		// }

    		if (extendElementName) {
    			// if (version == 1) {
    			// 	console.log('define', name);
    			// 	components[ name ] = window.customElements.define( name, component, {
    			// 		extends: extendElementName,
    			// 	});
    			// }
    			// else {
    			components[name] = document.registerElement(name, {
    				extends: extendElementName,
    				prototype: Object.create(component.prototype)
    			});
    			//}
    		} else {
    				// if (version == 1) {
    				// 	console.log('define', name);
    				// 	components[ name ] = window.customElements.define( name, component );
    				// }
    				//else {
    				components[name] = document.registerElement(name, component);
    				//}
    			}
    	}
    }

    /**
     * custom event manager mixin
     */
    var EventDispatcherMixin = {

      /**
       *  new event callback on the view chanel
       */
      on: function (event, callback, ctx) {

        this.callbackStack = this.callbackStack || {};

        this.callbackStack[event] = this.callbackStack[event] || {
          evtName: event,
          evtCbArr: []
        };
        this.callbackStack[event].evtCbArr.push({
          fn: callback,
          ctx: ctx !== void 0 ? ctx : this
        });
      },

      /**
       *  new event callback on the view chanel
       */
      off: function (event, callback) {

        if (this.callbackStack === void 0) {
          return;
        }

        if (this.callbackStack[event] !== void 0) {
          for (var i = 0, l = this.callbackStack[event].evtCbArr.length; i < l; i++) {
            if (this.callbackStack[event].evtCbArr[i].fn == callback) {
              this.callbackStack[event].evtCbArr.splice(i, 1);
              i--;
              l--;
            }
          }
        }
      },

      trigger: function (event) {
        utils.warn('event.trigger is deprecated, please use .fire() from now');
        this.fire(event);
      },

      /**
       *  trigger event on the view chanel
       */
      fire: function (eventName) {

        if (this.callbackStack && this.callbackStack[eventName] !== void 0) {
          for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            args[_key - 1] = arguments[_key];
          }

          //       if (/(c|subC)hange\:/g.test(eventName)
          //           && (
          //               args[2] === void 0 ||
          //               (typeof args[2] === "object" && args[2] !== null && args[2].numAdded === 0 && args[2].numRemoved === 0)
          //               ) ) { //if infos === undefined because we don't want to batch array modifcations for now

          //         this._batchList = this._batchList || {};

          //         // if (this._batchList[eventName] === void 0) {
          //         //   this._batchList[eventName] = null;//null is used as a flag to diff it with undefined
          //         // }

          //         // else {
          //         //   //if the event is a subChange and that a change is already on the queue, don't trigger the subchange
          //         //   if (/subChange\:/.test(eventName)
          //         //       && this._batchList[eventName.replace(/subChange/, 'change')] !== void 0 ) {
          //         //       return;
          //         //   }

          //         //   //if the event is a chnage and that a subChange is already on the queue, remove the subchange
          //         //   if ( /change\:/.test(eventName)
          //         //       && this._batchList[eventName.replace(/change/, 'subChange')] !== void 0) {
          //         //     delete this._batchList[eventName.replace(/change/, 'subChange')];
          //         //   }

          //           this._batchList[eventName] = args;
          //           return;
          // //        }

          //       }

          for (var i = 0, l = this.callbackStack[eventName].evtCbArr.length; i < l; i++) {
            if (this.callbackStack[eventName].evtCbArr[i] !== void 0) {
              this.callbackStack[eventName].evtCbArr[i].fn.apply(this.callbackStack[eventName].evtCbArr[i].ctx, args);
            }
          }
        }

        //  if (!this._isqueingBatch) {
        //    this._isqueingBatch = true;
        //    EventDispatcher.on('requestAnimationFrame', this._resolveBatch, this);
        //  }
      }

    };

    var arrayProto = Array.prototype;
    var arrayMethods = Object.create(arrayProto);
    var arrayKeys = Object.getOwnPropertyNames(arrayMethods);

    var observersArr = [];
    // var tearDown = false;
    // var tearDownTimer;

    //EventDispatcher.on('requestAnimationFrame', resolveAllBatches, this);

    function resolveAllBatches() {

      // clearTimeout(tearDownTimer);
      // tearDown = true;

      for (var i = 0, l = observersArr.length; i < l; i++) {
        observersArr[i]._resolveParentBatch();
      }

      // // end the execution stack
      // tearDownTimer = setTimeout(()=>{
      //   tearDown = false;
      // }, 0);

      requestAnimationFrame(resolveAllBatches);
    }

    requestAnimationFrame(resolveAllBatches);

    EventDispatcher.on('force-resolve-binding', resolveAllBatches);

    //for each public array methods
    ;['push', 'pop', 'shift', 'unshift', 'splice', 'sort', 'reverse'].forEach(function overrideArrayMethod(method) {

      // cache original array method
      var original = arrayProto[method];

      //rewrite array method using same name, still calling old method
      //we need to override method not to force user to use $push/$pop/$slice
      Object.defineProperty(arrayProto, method, {
        enumerable: true,
        writable: true,
        configurable: true,
        value: function mutator() {

          //duplicate received arguments
          //into a new array to break refence passing
          var i = arguments.length;
          var args = new Array(i);
          while (i--) {
            args[i] = arguments[i];
          }

          if (this.__ob__) {
            this.__ob__.disable();
          }

          // compute returned value using original method
          // with the dulicated attributes
          var result = original.apply(this, args);

          // this.length = tempArray.length;

          //if observer found on this array
          if (this.__ob__) {

            this.__ob__.enable();

            var infos = void 0;

            //retrieve added new items into array
            //for insertion methods only
            //observe the new item and check it it an array/object
            //if so create a new $Observer on it or retrieve existing one
            switch (method) {

              //the Array PUSH method receives the items to add at the end
              //of the array [].push( newItem, newItem, ... )
              case 'push':

                if (args) {
                  //this.__ob__.observeArrayItems(args);
                  var currentMaxIndex = this.length - args.length;
                  for (var j = 0; j < args.length; j++) {
                    this.__ob__.observe(this, currentMaxIndex + j, args[j]);
                    this.__ob__.defineReactive(this, currentMaxIndex + j, args[j]);
                  }
                  infos = { index: currentMaxIndex, numAdded: args.length, numRemoved: 0 };
                }
                break;

              //the Array UNSHIFT method receives the items to add at the start
              //of the array [].unshift( newItem, newItem, ... )
              case 'unshift':
                //unshift( newItem, newItem, ...)
                if (args) {
                  this.__ob__.observeArrayItems(args);
                  infos = { index: 0, numAdded: args.length, numRemoved: 0 };
                }
                break;

              // [].splice(startIndex,howManyItemsToRemove, newItem, newItem, ...)
              case 'splice':
                //so we only select the new items by
                //retrieving args starting at index 2 until the end of the args array
                // console.log('splice', {index: Number(args[0]), numAdded: args.slice(2).length, numRemoved: Number(args[1])});
                this.__ob__.observeArrayItems(args.slice(2));
                infos = { index: Number(args[0]), numAdded: args.slice(2).length, numRemoved: Number(args[1]) };
                break;

              case 'pop':
                if (this.length > 0) {
                  infos = { index: this.length + args.length, numAdded: 0, numRemoved: 1 };
                }
                break;

            }

            //we use 'arrayMethod' instead of a key; It's useless for now to tell the array observer exactly which key chnaged because we use Infos for that
            this.__ob__.notify('change:arrayMethod', /*null, null,*/infos, true);
          }

          //return value computed by original array method
          //because we don't want to disturb any code that would use arrays
          return result;
        }
      });
    });

    var $Observer = function () {
      function $Observer(scope, key, value) {
        babelHelpers.classCallCheck(this, $Observer);


        observersArr.push(this);

        this.obj = value;

        this.enabled = true;

        Object.defineProperty(this.obj, '__ob__', {
          value: this,
          //when looping on this obj, we don't want to log __obj__ to avoid infinite loop
          enumerable: false,
          writable: true,
          configurable: true
        });

        this.parents = [];
        this.keysOnParent = [];

        if (scope !== void 0) {
          this.parents.push(scope);
        }
        if (key !== void 0) {
          this.keysOnParent.push(key);
        }

        //is what the $observer observes is an array
        if (isArray(this.obj)) {

          // //override it's methods to add notifications
          // var i = arrayKeys.length;
          // while (i--) {
          //   defineProperty(this.obj, arrayKeys[i], arrayMethods[ arrayKeys[i] ]);
          // }

          this.observeArrayItems(this.obj);
        } else {
          this.observeObjectKeys(this.obj);
        }
      }

      $Observer.prototype.disable = function disable() {
        this.enabled = false;
      };

      $Observer.prototype.enable = function enable() {
        this.enabled = true;
      };

      $Observer.prototype.observeArrayItems = function observeArrayItems(items) {
        var i = items.length;
        while (i--) {
          this.observe(this.obj, i, items[i]);
          //add getter/setter for each item of the array
          //using index as a key
          this.defineReactive(this.obj, i, items[i]);
        }
        //this.defineReactive (this.obj, 'length', this.length);
      };

      $Observer.prototype.observeObjectKeys = function observeObjectKeys(obj) {
        var keys = Object.keys(obj);
        var i = keys.length;
        while (i--) {
          this.defineReactive(this.obj, keys[i], obj[keys[i]]);
        }
      };

      $Observer.prototype.defineReactive = function defineReactive(obj, key, val) {

        var self = this;

        // cater for pre-defined getter/setters
        var getter, setter;

        //returns the eventual descriptor set on this object's key
        //cf: Object.defineProperty(obj, prop, descriptor)
        var property = Object.getOwnPropertyDescriptor(obj, key);

        //if it is not a configurable property, return.
        if (property && property.configurable === false) {
          return;
        }

        //retrieve eventual getter/setter for this property
        getter = property && property.get;
        setter = property && property.set;

        //check if the value is object or array
        //if it is,
        //   return existing $Observer found on it (as value.__ob__)
        //   or create a new one (new $Observer)
        var childOb = this.observe(obj, key, val);

        var changeEventName = 'change:' + key;

        Object.defineProperty(obj, key, {
          enumerable: true,
          configurable: true,
          get: function reactiveGetter() {

            return val;

            // //if a getter exists on this key, use it
            // //else simply use the value
            // var value = getter ? getter.call(obj) : val

            // //fire chnage event on this property
            // //self.fire('get');

            // //if the value is object or array
            // //call chnage on the __ob__
            // // if (childOb) {
            // //   childOb.fire('get');
            // // }

            // // if (_.isArray(value)) {
            // //   //loop on each array value and fire notification
            // //   //dont use reversed while loop because we want to fire
            // //   //notifications on each observer as they are ordered in the array
            // //   for (var e, i = 0, l = value.length; i < l; i++) {
            // //     e = value[i]
            // //     if(e && e.__ob__){
            // //       e.__ob__.fire('get');
            // //     }
            // //   }
            // // }
            // return value
          },

          set: function reactiveSetter(newVal) {

            //retrieve the value
            //var value = getter ? getter.call(obj) : val;

            //if same value, don't do anything
            if (newVal === val) {
              return;
            }

            if (newVal !== void 0 && newVal !== null && typeof newVal === "object" && newVal.__ob__ !== void 0 && !newVal.__ob__.parents.includes(obj)) {
              //newVal.__ob__.disable();
              newVal.__ob__.parents.push(obj);
              newVal.__ob__.keysOnParent.push(key);
              //newVal.__ob__.enable();
            }

            //TODO use a flag for this option
            // if (typeof val === "number"
            //     && typeof newVal === "number"
            //     && Math.abs(newVal-val) < 0.0001 ) {
            //     return;
            // }

            //if setter found; use it
            // if (setter) {
            //   setter.call(obj, newVal)
            // } else {
            val = newVal;
            // }

            //check if newVal is object||array
            ////if so create $observer on it or return existing one
            self.observe(obj, key, newVal);
            //firechange on the observer, passing the changed key

            if (!self.enabled) {
              return;
            }

            //self.fire('change:' + key, val, newVal );

            //console.timeStamp(self.keysOnParent[0] + ' change:'+key + ' val:'+val + ' newVal:'+newVal);

            //for array, if an item is chnage using the syntax
            //     array[index] = val
            // we may need to call the parents chnage method.
            // if not, only the array wil be notified that aone of its item has changed

            // if (_.isArray(self.obj)
            //     && self.parents
            //     && typeof self.parents.__ob__ !== "undefined") {
            //     self.parents.__ob__.fire('change:'+self.keysOnParent);
            // }

            //here we notify the parents observer, that the object chnaged
            //then we go up the observer tree until no observer parents is found and trigger a chnage on each levels

            // case if the changing key is inside an array/object
            // and a chnage callback as been attached to it.
            //TODO if we need to check if there a chnage callback to opt perf

            self.notify(changeEventName, /*val, newVal, */null, true);
          }

        });
      };

      $Observer.prototype.notify = function notify(eventName, /*oldValue, newValue,*/infos, forceParentChange) {

        this._notifyBatchList = this._notifyBatchList || {};

        if (this.callbackStack !== void 0 && this.callbackStack[eventName] !== void 0) {

          //TODO merge array manipulation
          if (infos === void 0 || typeof infos === "object" && infos !== null && (infos.numAdded !== 0 || infos.numRemoved !== 0)
          /*|| ((this._notifyBatchList[eventName] === void 0 || this._notifyBatchList[eventName] === null) && tearDown)*/) {

              this.fire(eventName, /*oldValue, newValue,*/infos);

              //we set a flag(the null value) to diff it with void 0
              // if (this._notifyBatchList[eventName] === void 0 && tearDown) {
              //   this._notifyBatchList[eventName] = null;
              // }
            } else {

              //batch chnage only if this observer has callbacks
              if (this._notifyBatchList[eventName] === void 0 || this._notifyBatchList[eventName] === 0) {
                // this._notifyBatchList[eventName] = {
                //   // oldValue:oldValue,
                //   // newValue:newValue,
                //   infos: infos
                // };
                this._notifyBatchList[eventName] = 1; //set flag to trigger chnage on next resolve
              } else {

                  return;
                  // this._notifyBatchList[eventName].oldValue = oldValue;
                  // this._notifyBatchList[eventName].newValue = newValue;
                  //this._notifyBatchList[eventName].infos = infos;
                }
            }
        }

        if (!this._dirty
        // || forceParentChange
         || typeof infos === "object" && infos !== null && (infos.numAdded !== 0 || infos.numRemoved !== 0)) {

          this._dirty = true;

          for (var i = 0, l = this.parents.length; i < l; i++) {
            if (this.parents[i].__ob__ !== void 0 && this.keysOnParent[i] !== 'props') {
              this.parents[i].__ob__.notify((forceParentChange ? "change:" : "subChange:") + this.keysOnParent[i], /*oldValue, newValue,*/infos);
            }
          }
        }
      };

      $Observer.prototype._resolveParentBatch = function _resolveParentBatch() {

        if (this._notifyBatchList === void 0) {
          return;
        }

        var keys = Object.keys(this._notifyBatchList);
        var i = keys.length;
        while (i--) {

          // console.timeStamp('notify :: ' +  keys[i]  + ' oldValue:'+this._notifyBatchList[ keys[i] ].oldValue + ' newValue:'+this._notifyBatchList[ keys[i] ].newValue);

          // this.fire(
          //    keys[i] ,
          //   this._notifyBatchList[ keys[i] ].oldValue,
          //   this._notifyBatchList[ keys[i] ].newValue,
          //   this._notifyBatchList[ keys[i] ].infos
          // );

          if (this._notifyBatchList[keys[i]] !== 0 && this.callbackStack !== void 0 && this.callbackStack[keys[i]] !== void 0) {

            for (var j = 0, l = this.callbackStack[keys[i]].evtCbArr.length; j < l; j++) {
              if (this.callbackStack[keys[i]].evtCbArr[j] !== void 0) {
                // this.callbackStack[ keys[i] ].evtCbArr[j].fn.call(
                //   this.callbackStack[ keys[i] ].evtCbArr[j].ctx,
                //   // this._notifyBatchList[ keys[i] ].oldValue,
                //   // this._notifyBatchList[ keys[i] ].newValue,
                //   this._notifyBatchList[ keys[i] ].infos
                // );

                this.callbackStack[keys[i]].evtCbArr[j].fn.call(this.callbackStack[keys[i]].evtCbArr[j].ctx);
              }
            }
          }

          this._notifyBatchList[keys[i]] = 0;
        }

        // for (var eventName in this._notifyBatchList) {

        // }

        this._dirty = false;
      };

      $Observer.prototype.observe = function observe(scope, key, value) {
        //if is undefined || is not an array nor an object
        if (value === void 0 || value === null || typeof value !== 'object') {
          return;
        }

        if (value.__ob__ !== void 0 /*value.hasOwnProperty('__ob__')*/ /*&& value.__ob__ instanceof $Observer*/) {
            return; // value.__ob__;
          } else if (typeof value === "object" && !Object.isFrozen(value)) {
            return new $Observer(scope, key, value);
          }
      };

      return $Observer;
    }();

    for (var k$1 in EventDispatcherMixin) {
      $Observer.prototype[k$1] = EventDispatcherMixin[k$1];
    }

    //TODO:: add multiple selector on events manager

    var LIGHTDOM_UUID = 0;

    /**
     * @extends Event to get .on/.off/.trigger methods
     * TODO: check if it is better to use a mixins instead of inherit
     *       if we use a mixins it mean the on/off/trigger are supposed to be used by another component
     *       or we can simply let the EventDispatcher inherit from Event
     */
    var ComponentMixin = {

      _isInTemplate: function _isInTemplate() {

        var _isInTemplate = false;
        var node = this;
        while (node.parentNode && node.parentNode !== document.body) {
          if (node.parentNode.tagName === "TEMPLATE" || node.parentNode._isLightDom) {
            _isInTemplate = true;
            break;
          }
          node = node.parentNode;
        }

        return _isInTemplate;
      },

      createdCallback: function createdCallback() {

        if (this._isInTemplate()) {
          return;
        }

        this._isCreated = true;

        this._id = 0;

        /**
         * may implt this only for displayobjects
         */
        this.visible = true;

        /**
         * in some really specificcase, we might need to pass down datas from a parent component to deep sub component
         * So in order to avoir the creation a attributes and props on in-between component, we can add thoses datas on the context object
         *  /!\ context is passed by reference, so a child component can edit the context of a parent component.
         * morevoer, context is not clones, but override the context of the child component.
         */
        this.context = {};

        /**
         * First retrieve defaultProps, and deserialize attrbutes
         */
        this.props = {};

        /**
         * save props chnage when component is disabled
         */
        this._savePropChange = {};

        /**
         * list of events managed by event delegation
         */
        this._delegateEvents = {};

        /**
         * cache the defualt props object not to force the getter on each use
         */
        if (this._defaultProps === void 0) {
          //this._defaultProps = this._defaultProps || this.defaultProps;
          this._defaultProps = this.defaultProps;
        }

        /**
         * hydrate this.props from the defaultProps getter
         */
        this._getPropsFromDefaultProps();

        /**
         * cache the default events object not to force the getter on each use
         */
        this._events = this.events;

        /**
         * cache the default template not to force the getter on each use
         */
        this._template = this.template;

        /**
         * cache the default template not to force the getter on each use
         */
        this._styles = this.styles !== void 0 ? this.styles.replace(/\:host/g, this.tagName.toLowerCase()) : null;

        /**
         * then create an observer on the props
         */
        this._observer = new $Observer(this, 'props', this.props);

        this._defaultPropsChangeCallbacks = {};

        /**
         *  TODO: bug in EventDispatcher if two callbacks on an event,
         *        with the same name and no binding assigned on it
         */
        this.bindMethods(["_onDelegateEvent", "_resize", '_resizeEnd']);

        if (this.update !== void 0) {
          this._update = this._update.bind(this);
        }

        //public alias for createdCallback
        if (this.created) {
          this.created();
        }
      },

      /**
       * init children / manipulate DOM / cache refs
       * private attached method.
       * user should not override it.
       * or if he does, he must call super.attachedCallback()
       */
      attachedCallback: function attachedCallback() {
        var _this = this;

        if (this._isInTemplate() || !this._isCreated) {
          return;
        }

        /**
         * Async to make sure attached is always callaed after created and after checkNode from Template
         * we use 10ms delat because in Chrome, the attached callback is called juste after the createdcallback
         */
        //  this._readyTimer = setTimeout(()=>{

        this._deserializeAttributes();

        this._retrieveLightDOM();

        // TODO: mobe this inside createdCallback except for $content passing
        this._retrieveTemplate();

        this._generateCompositedDOM();

        /**
         * We bind the chnage here to trigger first chnage on attribute deserialization
         */

        var _loop = function (p) {

          if (_this._defaultProps[p] && _this._defaultProps[p].change) {

            if (_this[_this._defaultProps[p].change] === void 0) {
              utils.warn('Cannot bind change on undefined method:' + _this._defaultProps[p].change);
            } else {

              _this._defaultPropsChangeCallbacks[p] = function ( /*oldValue,newValue,*/infos) {

                if (!_this._isAttached) {
                  return;
                }

                if (_this.visible === false) {
                  _this._savePropChange[p] = infos ? typeof _this._savePropChange[p] == 'object' ? _this._savePropChange[p].push(infos) : [infos] : 1;
                  return;
                }

                _this[_this._defaultProps[p].change]( /*oldValue,newValue,*/infos);
              };

              _this.props.__ob__.on('change:' + p, _this._defaultPropsChangeCallbacks[p]);

              // this.props.__ob__.on('subChange:'+p, (oldValue,newValue,infos)=>{
              //     this[ this._defaultProps[p].change ](oldValue,newValue,infos);
              // });
            }
          }
        };

        for (var p in this._defaultProps) {
          _loop(p);
        }

        //TODO:
        //this._readyTimer = setTimeout(()=>{

        if (this.attached) {
          this.attached();
        }

        this.fire('attached', this.index);

        //this._readyTimer = setTimeout(()=>{

        this._isAttached = true;

        if (this._template && this._shadowDOM && this._isShadowDOMReady || !this._template) {
          if (this.tagName !== 'TEMPLATE') {
            this._ready();
          }
        }

        // },10);

        // }, 0);

        //}, 10);
      },

      _getPropsFromDefaultProps: function _getPropsFromDefaultProps() {

        for (var p in this._defaultProps) {
          if (utils.isObject(this._defaultProps[p])) {
            if (this._defaultProps[p].value !== void 0) {
              this.props[p] = this._defaultProps[p].value;
            } else {
              // TODO: pass an object as value without setting the type is a bad practice
              this.props[p] = this._defaultProps[p];
            }
          } else {
            // case passing a string directly
            this.props[p] = this._defaultProps[p];
          }
        }
      },

      _safeParseJSON: function (value, propName) {
        try {
          return JSON.parse(value);
        } catch (e) {
          utils.warn('invalid value \'' + value + '\' for the \'' + propName + '\' property; it must be Object type');
          return;
        }
      },


      setProp: function setProp(propName, value) {

        if (this._defaultProps === void 0 || this._defaultProps[propName] === void 0 || this.props === void 0 || this.props[propName] === value) {
          return;
        }

        //if value match mustahced, return, and let prop-binding do it's job
        if (typeof value == 'string' && /\{\{[^{}]*\}\}/g.test(value)) {
          return;
        }

        //if no type is set, simply set the attribute as a string
        //TODO case for data-foo='{"hello":"world"}' => gives an object as the browser will JSON.parse it
        if (typeof this._defaultProps[propName] !== "object" || this._defaultProps[propName] === null || typeof this._defaultProps[propName] === "object" && this._defaultProps[propName].type === void 0) {
          //this.props.set(propName, value);
          this.props[propName] = value;
          return;
        }

        var isFunction = false;

        if (this._defaultProps[propName] && this._defaultProps[propName].type) {

          if (this._defaultProps[propName].type == "array" || this._defaultProps[propName].type == "arr" || this._defaultProps[propName].type == "json" || this._defaultProps[propName].type == "object" || this._defaultProps[propName].type == "obj") {

            if (value) {

              if (typeof value === "string") {
                value = this._safeParseJSON(value, propName);
              }

              if (typeof this.props[propName] !== 'object' || this.props[propName] === null) {
                this.props[propName] = typeof value === 'object' && value !== null ? value : JSON.parse(value);
              } else {

                //this.deepReplace(this.props[propName], value, propName);

                if (this.props[propName] !== value) {

                  /**
                   * OPTIMIZATION: 
                   * if array, and array dont have observer,
                   * simply copy the value to the old array so that no observer are created
                   */
                  if (this.props[propName] !== value && value.length && this.props[propName].length === value.length && !value.__ob__) {

                    for (var i = 0; i < value.length; i++) {
                      this.props[propName][i] = value[i];
                    }
                  } else {
                    this.props[propName] = value;
                    // if (value !== void 0
                    //     && typeof value === "object"
                    //     && value !== null
                    //     && !value.__ob__.parents.includes(this.props)) {
                    //     value.__ob__.disable();
                    //     value.__ob__.parents.push(this.props);
                    //     value.__ob__.keyOnParent.push(propName);
                    //     value.__ob__.enable();
                    // }
                  }
                }
              }
            }
          }

          if (this._defaultProps[propName].type === "string" || this._defaultProps[propName].type === "str") {
            this.props[propName] = typeof value === "string" ? value : JSON.stringify(value);
          }

          if (this._defaultProps[propName].type === "bool" || this._defaultProps[propName].type === "boolean") {
            this.props[propName] = value === "false" || value === "" || !value ? false : true;
          }

          if (this._defaultProps[propName].type === "float" || this._defaultProps[propName].type === "f") {
            this.props[propName] = typeof value !== "number" ? parseFloat(value, 10) : value;
          }

          if (this._defaultProps[propName].type === "int" || this._defaultProps[propName].type === "i") {
            this.props[propName] = typeof value !== "number" ? parseInt(value, 10) : value >> 0;
          }

          if (this._defaultProps[propName].type === "func" || this._defaultProps[propName].type === "fn" || this._defaultProps[propName].type === "function") {
            if (typeof value === "function") {
              isFunction = true;
              this.props[propName] = value;
            }
          }
        }

        //update the corresponding attribute if reflect mode
        //dont update if is is a function as we only want to keep the function name in the attribute
        if (this._defaultProps[propName].reflect === true) {
          this.setAttribute(utils.hyphenise(propName), value);
        }

        // this.attributeChanged();
      },

      // attributeChanged: function(){
      //   //...
      // },

      _deserializeAttributes: function _deserializeAttributes() {

        //first we loop through attribute
        //if any of them match data-on , consider it it a callbackProps
        for (var i = 0, l = this.attributes.length; i < l; i++) {

          var formatedPropName = utils.camelCalise(this.attributes[i].nodeName.replace(/^data\-/, ""));

          if (this.attributes[i].nodeValue !== "") {
            this.setProp(formatedPropName, this.attributes[i].nodeValue);
          }
        }
      },

      _retrieveLightDOM: function _retrieveLightDOM() {
        var _this2 = this;

        if (!this._template) {
          return;
        }

        //any childNode inside a template tag should be moved to it's content key.
        //Thus we ignore any childNodes for browser that do notsupport naive template tag
        if (this.tagName === "TEMPLATE") {
          return;
        }

        this._lightDOMUUID = LIGHTDOM_UUID;

        this._lightDOM = document.createDocumentFragment();
        this._lightDOM._isLightDom = true;

        while (this.hasChildNodes()) {
          this._lightDOM.appendChild(this.childNodes[0]);
        }

        for (var i = 0, l = this._lightDOM.childNodes.length; i < l; i++) {
          this._eachNodes(this._lightDOM.childNodes[i], function (subNode) {
            if (subNode.attributes) {
              subNode.setAttribute('light-dom-id', _this2._lightDOMUUID);
            }
          });
        }

        LIGHTDOM_UUID++;
      },

      _retrieveTemplate: function _retrieveTemplate() {

        if (this.tagName === "TEMPLATE") {
          return;
        }

        if (this._template) {

          if (this._styles) {
            this._stylesTag = document.createElement('style');
            this._stylesTag.innerHTML = this._styles;
            this.appendChild(this._stylesTag);
          }

          this._shadowDOM = document.createElement('template', 'light-core-template');

          //add an attribute on this component to differenciate it with other template components
          //TODO: iplt real shadow-dom if possible
          //      the .$(selector) should only look for lightDOM children
          this._shadowDOM.setAttribute('shadow-dom', '');
          this._shadowDOM.setAttribute('parent-tag', this.tagName.toLowerCase());
          this._shadowDOM._scope = this.props;
          this._shadowDOM._componentContext = this;

          this._shadowDOM.context = this.context;

          this._shadowDOM._$slot = this._lightDOM;
          this._shadowDOM._slotuuid = this._lightDOMUUID;

          if (typeof this._template === "string") {
            /**
             * convert the template string to real DOM nodes
             * this way we don't need to manipulate DOM as strings but realNodes
             */
            var div = document.createElement('div');
            //we append the div to the shadow before setting the innerHTML not to execute the components
            //TODO: check if it always work or if in some case, the createdCallback is called
            this._shadowDOM.content.appendChild(div);
            div.innerHTML = this._template;

            while (div.hasChildNodes()) {
              this._shadowDOM.content.appendChild(div.childNodes[0]);
            }

            this._shadowDOM.content.removeChild(div);
          } else {
            this._shadowDOM.content.appendChild(this._template);
          }

          this.bindMethods(['_onShadowDOMReady']);
          this._shadowDOM.on('ready', this._onShadowDOMReady, this);
        }
      },

      _eachNodes: function _eachNodes(node, cb) {

        if (!node) {
          return;
        }

        if (node._$parentUUID !== void 0 && this._uuid !== void 0 && node._$parentUUID != this._uuid) {
          return;
        }

        cb(node);

        //don't parse template's childNodes for browsers that do not support template tag
        if (node && node.tagName !== "TEMPLATE") {

          for (var i = 0, l = node.childNodes.length; i < l; i++) {
            //TODO: in some cases node.childNodes[i] is undefined
            // it has something to do with the <content> tag beeing removed/replaced
            // must implt a method to break the eachNodes loop
            if (node.childNodes[i] && node.childNodes[i].nodeType != 8) {
              this._eachNodes(node.childNodes[i], cb);
            }
          }
        }
      },

      _generateCompositedDOM: function _generateCompositedDOM() {

        if (this.tagName === "TEMPLATE") {
          return;
        }

        // if( !this._template && this._lightDOM ){
        //   this.appendChild( this._lightDOM );
        // }

        if (this._template && this._shadowDOM) {
          /**
           * append template after
           */
          this.appendChild(this._shadowDOM);
        }
      },

      /**
       * DOM of the component is attached
       * and DOM of all children is attached
       */
      _ready: function _ready() {

        //clearTimeout( this._readyTimer );

        this._isReady = true;

        //console.log('READY', this);
        this.fire('ready', this.index);

        if (this.ready) {
          this.ready();
        }

        this.setAttribute('ready', "");

        /**
         * Parse the this.event object and bind events
         */
        this._initEvents();

        /**
         * listen to the global resize event
         */
        EventDispatcher.on('resize', this._resize, this);
        EventDispatcher.on('resizeend', this._resizeEnd, this);

        this._resize();
      },

      _onShadowDOMReady: function _onShadowDOMReady() {

        this._shadowDOM.off('ready', this._onShadowDOMReady, this);

        this._isShadowDOMReady = true;

        if (this._isAttached && !this._isReady) {
          //this._readyTimer = setTimeout(()=>{
          this._ready();
          //}, 10);
        }
      },

      /**
       * init event delegation based on the event getter
       * get events(){
       *   return {
       *     "eventName (selector|this.el)" : "eventCallback"
       *   }
       * }
       */
      _initEvents: function _initEvents() {

        for (var eventKey in this._events) {

          if (this._events.hasOwnProperty(eventKey)) {

            var methodName = this._events[eventKey];
            var eventElements = eventKey.split(" ");

            this._registerEvent(eventElements[0], eventElements[1], methodName);
          }
        }
      },

      _registerEvent: function _registerEvent(eventName, selector, methodName) {
        // console.log('registerevent', this, eventName, selector);

        //pointerenter and pointerleave do not propagate so replace it with pointerover/pointerout
        //we need to do a check on the callback not to trigger enter/leave if we roll over/out a child of the node
        if (eventName === "pointerenter") {
          eventName = "pointerover";
        } else if (eventName === "pointerleave") {
          eventName = "pointerout";
        }

        /**
         * TODO: 
         * check if support[pointerXXX] exists in support
         * we uyse multi- because some device use touch+mouse
         * support[multi] will return an array with the converted eventNames
         */
        eventName = /pointer/.test(eventName) ? support$1['multi' + eventName] : [eventName];

        if (this[methodName] !== void 0) {

          this.bindMethods(methodName);

          for (var i = 0; i < eventName.length; i++) {

            if (this._delegateEvents[eventName[i]] === void 0) {
              this._delegateEvents[eventName[i]] = [];
              //TODO: use document instead of node...
              this.addEventListener(eventName[i], this._onDelegateEvent);
            }

            this._delegateEvents[eventName[i]].push({
              selector: selector,
              callback: this[methodName]
            });
          }
        } else {
          throw new Error('oups, there isnt any ' + methodName + ' method defined for this view');
        }
      },

      _onDelegateEvent: function _onDelegateEvent(originalEvent) {

        /**
         * TODO:
         * on device with touch+mouse, events may be triggered twice
         * thought we check if a touch/mouse event is follwed by a mouse/touch event less than 300ms layer:
         * a user cannot click and touch in less than 300ms
         */
        if (this._eventNeedsCheck) {
          if (/touch/.test(originalEvent.type) && /mouse/.test(this._eventNeedsCheckType) || /mouse/.test(originalEvent.type) && /touch/.test(this._eventNeedsCheckType)) {

            if (Date.now() - this._eventNeedsCheckTime < 300) {
              return;
            }
          }
        }

        if (originalEvent.type === 'touchstart' || originalEvent.type === 'touchend' || originalEvent.type === 'mousedown' || originalEvent.type === 'mouseup') {
          this._eventNeedsCheckType = originalEvent.type;
          this._eventNeedsCheck = true;
          this._eventNeedsCheckTime = Date.now();
        } else {
          this._eventNeedsCheck = false;
        }

        var delegateEvents = this._delegateEvents[originalEvent.type];
        var _stopPropagation = false;

        for (var i = 0; i < delegateEvents.length; i++) {

          if (_stopPropagation) {
            utils.notify('Event propagation has been stopped');
            break;
            return;
          }

          //if delegation
          if (delegateEvents[i].selector) {

            var related = originalEvent.relatedTarget;
            var node = originalEvent.target;

            while (node && node !== this) {

              if (typeof delegateEvents[i].selector === "string" && node.classList && node.classList.contains(delegateEvents[i].selector.replace('.', '')) || delegateEvents[i].selector === node) {
                /**
                 * special case for mouseover/mouseout as it is triggered by subnode mouseover/mouseout
                 * which is in most case the deisred behaviour
                 * we check if the related (it is the element matched by the mouse after the mouseout/mouseover event)
                 * is inside the node. If it is, it means we did not really "over" or "out" the node so no need to trigger callback
                 */
                if (originalEvent.type !== "mouseover" && originalEvent.type !== "mouseout" || !node.contains(related)) {
                  var originalEventCopy = utils.clone(originalEvent);
                  originalEventCopy.currentTarget = node;
                  originalEventCopy.stopPropagation = function stopPropagation() {
                    _stopPropagation = true;
                  };
                  delegateEvents[i].callback(originalEventCopy);
                }
              }

              node = node.parentNode;
            }
          }

          /**
           * else it's binded to this.el so just trigger the callback
           */
          else {
              delegateEvents[i].callback(originalEvent);
            }
        }
      },

      _removeEvents: function _removeEvents() {

        for (var eventName in this._delegateEvents) {
          this.removeEventListener(eventName, this._onDelegateEvent);
        }

        if (this.update !== void 0) {
          EventDispatcher.off('requestAnimationFrame', this._update, this);
        }

        EventDispatcher.off('resize', this._resize, this);
        EventDispatcher.off('resizeend', this._resizeEnd, this);
      },

      detachedCallback: function detachedCallback() {

        this._isReady = false;
        this._isAttached = false;

        if (this._shadowDOM) {
          this._isShadowDOMReady = false;
          this._shadowDOM.off('ready', this._onShadowDOMReady, this);
        }

        //clearTimeout(this._readyTimer);
        clearTimeout(this._afterResizeTimer);

        this._observer = null;

        // clearTimeout(this._readyTimer);
        this._removeEvents();

        //remove default props change callbacks
        for (var p in this._defaultPropsChangeCallbacks) {
          this.props.__ob__.off('change:' + p, this._defaultPropsChangeCallbacks[p]);
        }

        if (this.detached !== void 0) {
          this.detached();
        }
      },

      /**
       * reflow the view/ set DOM elemnts size
       * call resize on subviews
       * attch the resize method to the global chanel resize event
       * private resize method.
       * use should not override this method.
       * or if he does, he must call super._resize()
       */
      _resize: function _resize() {
        var _this3 = this;

        if (!this._isReady) {
          return;
        }

        /**
         * call the public resize handler
         */
        if (this.resize) {
          this.resize();
        }

        /**
         *  we use asynch not to force calling super()
         *  at the very end of each overwritten methods
         *  super can be called at the begining
         */
        this._afterResizeTimer = setTimeout(function () {
          /**
           * resize is a sync function
           * so here we are sure all children have been resized
           * TODO: use event handler from child component instead of a timer
           */
          _this3._resized();
        }, 0);
      },

      /**
       * Handler for when all children have been resized
       * private method
       */
      _resized: function _resized() {

        if (!this._isReady) {
          return;
        }

        /**
         * call the public hanlder
         */
        if (typeof this.resized === "function") {
          this.resized();
        }

        /**
         * trigger an event on the component
         */
        this.fire('resized');

        if (this.update !== void 0) {
          EventDispatcher.off('requestAnimationFrame', this._update, this);
          EventDispatcher.on('requestAnimationFrame', this._update, this);
        }
      },

      _resizeEnd: function _resizeEnd() {
        /**
         * call the public hanlder
         */
        if (typeof this.resizeEnd === "function") {
          this.resizeEnd();
        }
      },

      _update: function _update() {
        if (this.visible) {
          this.update();
        }
      },

      _enable: function _enable() {

        this.visible = true;

        /**
         * TODO: Use classList polyfill
         */
        if (this.classList) {
          this.classList.remove('is-disabled');
        } else {
          var cur = ' ' + (this.getAttribute('class') || '') + ' ';
          var tar = ' ' + 'is-disabled' + ' ';
          while (cur.indexOf(tar) >= 0) {
            cur = cur.replace(tar, ' ');
          }
          this.setAttribute('class', cur.trim());
        }

        this.removeAttribute('is-disabled');

        if (this._shadowDOM) {
          this._shadowDOM.enable();
        }

        for (var k in this._savePropChange) {

          console.log('this._savePropChange', k);

          if (typeof this._savePropChange[k] == 'object') {
            for (var i = 0, l = this._savePropChange[k].length; i < l; i++) {
              this.props.__ob__.fire('change:' + k, this._savePropChange[k][i]);
            }
          } else {
            this.props.__ob__.fire('change:' + k);
          }
        }

        if (this.enable) {
          this.enable();
        }
      },

      _disable: function _disable() {

        this.visible = false;

        if (this.classList) {
          this.classList.add('is-disabled');
        } else {
          var cur = ' ' + (this.getAttribute('class') || '') + ' ';
          if (cur.indexOf(' ' + 'is-disabled' + ' ') < 0) {
            this.setAttribute('class', (cur + 'is-disabled').trim());
          }
        }

        this.setAttribute('is-disabled', '');

        if (this._shadowDOM) {
          this._shadowDOM.disable();
        }

        if (this.disable) {
          this.disable();
        }
      },

      /**
       * bind method to workd with EventDispatcher without changing it's name
       * no more need to do :
       *    this._methodName = this.methodName.bind(this)
       * simply do :
       *    this.bindMethods("myMethod", "myOtherMethod", "myLastMethod");
       */
      bindMethods: function bindMethods(methodNames) {
        var methodNames = typeof methodNames === "object" && methodNames !== null && methodNames.length ? methodNames : [methodNames];
        for (var i = 0, l = methodNames.length; i < l; i++) {
          var oldMethod = this[methodNames[i]];
          this[methodNames[i]] = oldMethod.bind(this);
        }
      }

    };

    var _HTMLElement;
    if (typeof HTMLElement !== 'function') {
      _HTMLElement = function () {};
      _HTMLElement.prototype = document.createElement('div');
    } else {
      _HTMLElement = HTMLElement;
    }

    var Component = function (_HTMLElement2) {
      babelHelpers.inherits(Component, _HTMLElement2);

      function Component() {
        babelHelpers.classCallCheck(this, Component);
        return babelHelpers.possibleConstructorReturn(this, _HTMLElement2.apply(this, arguments));
      }

      return Component;
    }(_HTMLElement);

    ;

    for (var k in ComponentMixin) {
      Component.prototype[k] = ComponentMixin[k];
    }

    for (var _k in EventDispatcherMixin) {
      Component.prototype[_k] = EventDispatcherMixin[_k];
    }

    var optionalParam = /\((.*?)\)/g;
    var namedParam = /(\(\?)?:\w+/g;
    var splatParam = /\*\w+/g;
    var escapeRegExp = /[\-{}\[\]+?.,\\\^$|#\s]/g;

    var StateProvider = {

      states: {},

      _routeToRegExp: function (route) {
        route = route.replace(escapeRegExp, '\\$&').replace(optionalParam, '(?:$1)?').replace(namedParam, function (match, optional) {
          return optional ? match : '([^/?]+)';
        }).replace(splatParam, '([^?]*?)');
        return new RegExp('^' + route + '(?:\\?([\\s\\S]*))?$');
      },

      add: function (stateName, options) {

        var options = utils.extend({
          controller: null,
          route: null
        }, //TODO:
        // deepState
        // stickyState: function(){},
        // deepStateRedirect: {
        //        default: { state: "foo.bar.baz.defaultSubState", params: { defaultStateParam1: "99" } },
        //        fn: function($dsr$) {}
        // }
        options || {});

        if (typeof options.controller == "object") {
          var controller = options.controller;
          var method = options.method || 'index';
          options.controller = controller[method].bind(controller);
        }

        //generate regular expression from route
        //extract namesParameters from route
        if (options.route) {
          options.regExp = this._routeToRegExp(options.route);
          options.paramList = this._extractParamsFromRoute(options.route);
        }

        this.states[stateName] = options;

        //chaining states
        return this;
      },

      initialize: function (options) {
        this.lastState = null;
        this.base = window.location.protocol + '//' + window.location.host + window.location.pathname + window.location.search;
        EventDispatcher.on('statechange', this.onStateChange, this);
        window.addEventListener('hashchange', this._onHashChange.bind(this));
      },

      //state chnage is trigger as internal events.
      //if statechnage is triggered, ignore following hashchnage to avoid infinite loops
      onStateChange: function (state, stateParams) {
        var _this = this;

        if (state in this.states) {

          //if the state as a route, save it to the url
          if (this.states[state].route) {
            clearTimeout(this.bypassTimer);
            this.bypass = true;
            window.location.hash = '#' + this.hrefFromParams(state, stateParams);
            this.bypassTimer = setTimeout(function () {
              _this.bypass = false;
            }, 50, this);
          }

          if (this.states[state].controller) {
            this.states[state].controller(stateParams);
          }
        }
      },

      _extractParamsFromRoute: function (route) {
        var args = route.match(namedParam);
        var params = {};
        for (var i = 0; i < args.length; i++) {
          args[i] = args[i].replace(':', '');
        }
        return args;
      },

      hrefFromParams: function (state, params) {

        if (!state in this.states) {
          return 'no state found :: ' + state;
        }

        if (!this.states[state].route) {
          return 'no route found';
        }

        var route = this.states[state].route;
        var originalRoute = route;
        for (var p in params) {
          var namedParamRegExp = new RegExp('(\\(\\?)?:' + p, 'g');
          var optionalParamRegExp = new RegExp('\\([]\\)', 'g');
          route = route.replace(namedParamRegExp, params[p]).replace(/(\(|\))/g, '');

          console.log("ROUTE", originalRoute, route);
        }

        return route;
      },

      getHashState: function () {
        this._onHashChange();
      },

      _onHashChange: function () {

        if (this.bypass) {
          return;
        }

        var self = this,
            state = this.getState(),
            args = [];

        //this.state = state;

        for (var s in this.states) {

          if (this.states[s].regExp && this.states[s].regExp.test(state)) {

            state.replace(this.states[s].regExp, function () {
              for (var a = 1; a < arguments.length - 3; a++) {
                if (typeof arguments[a] === "undefined") {
                  args.push("");
                } else {
                  args.push(arguments[a]);
                }
              }
            });

            var stateParams = {};

            for (var i = 0; i < args.length; i++) {
              stateParams[self.states[s].paramList[i]] = args[i];
            }

            EventDispatcher.fire('statechange', [s, stateParams]);

            // if (_.isFunction(this.states[s].controller)) {
            //   this.states[s].controller(stateParams);
            // }
            break;
          }
        }
      },

      getState: function () {
        return document.location.hash.replace(/^#\!?\/?/, '');
      }

    };

    var nativeEvents = ["drag", "dragend", "pointerenter", "pointerleave", "pointerdown", "pointerup", "pointermove", "click", "keyup", "keydown", "keypress", "blur", "change", "focus", "submit", "resize", "scroll"];

    var allowedKeywords = 'window,Math,Date,this,true,false,null,undefined,Infinity,NaN,' + 'isNaN,isFinite,decodeURI,decodeURIComponent,encodeURI,' + 'encodeURIComponent,parseInt,parseFloat,typeof,void';

    var allowedKeywordsRE = new RegExp('^(' + allowedKeywords.replace(/,/g, '\\b|') + '\\b)');

    var $Watcher = function () {
        function $Watcher(node, attrName, content, template) {
            babelHelpers.classCallCheck(this, $Watcher);


            this.enabled = true;

            this.node = node;
            this.attrName = attrName;
            this.content = content;
            this.template = template;

            this.stringParts = [];
            this.numStringParts = 0;
            this.lightDom = [];
            this.isTextNode = node.attributes ? false : true;

            this.removableAttr = false;

            this.onPathChange = this.onPathChange.bind(this);

            if (!this.isTextNode) {
                this.node.setAttribute('has-binding', '');
                if (/^\:/.test(this.attrName)) {
                    this.removableAttr = true;
                    this.attrName = this.attrName.replace(/^\:/, "");
                    this.node.removeAttribute(':' + this.attrName);
                }
                this.formatedPropName = utils.camelCalise(this.attrName.replace("data-", ""));
            } else {

                if (/\{\{\s*\@/.test(this.content)) {
                    var htmlNode = document.createElement('span');
                    this.content = this.content.replace(/\{\{\s*\@/, "{{");
                    if (this.node.parentNode) {
                        this.node.parentNode.replaceChild(htmlNode, this.node);
                        this.node = htmlNode;
                    } else {
                        this.oldNode = this.node;
                        this._onDOMNodeInserted = this._onDOMNodeInserted.bind(this);
                        this.oldNode.addEventListener('DOMNodeInserted', this._onDOMNodeInserted, false);
                    }
                    this.node = htmlNode;
                }
            }

            this.parseExpression();
            this.attachListeners();

            this.onPathChange();
        }

        $Watcher.prototype._onDOMNodeInserted = function _onDOMNodeInserted() {
            this.oldNode.removeEventListener('DOMNodeInserted', this._onDOMNodeInserted, false);
            if (this.oldNode.parentNode) {
                this.oldNode.parentNode.replaceChild(this.node, this.oldNode);
            }
        };

        $Watcher.prototype.attachListeners = function attachListeners() {

            for (var i = 0, l = this.numStringParts; i < l; i++) {

                if (this.stringParts[i].type === "expression") {

                    for (var j = 0, _l = this.stringParts[i].value.pathRoots.length; j < _l; j++) {

                        var isBinded = false;

                        if (this.template._item !== null && this.stringParts[i].value.pathRoots[j] === '$value') {
                            isBinded = true;
                            this.template._item.__ob__.on('subChange:' + this.template.props.itemIndex, this.onPathChange);
                            this.template._item.__ob__.on('change:' + this.template.props.itemIndex, this.onPathChange);
                        }

                        if (this.template.props.repeaterKey !== null) {
                            for (var key in this.template.props.repeaterKey) {
                                if (this.stringParts[i].value.pathRoots[j] === key && this.template.props.repeaterKey[key].repeaterParentProps.repeat !== null) {
                                    isBinded = true;
                                    this.template.props.repeaterKey[key].repeaterParentProps.repeat.__ob__.on('subChange:' + this.template.props.repeaterKey[key].repeaterProps.itemIndex, this.onPathChange);
                                    this.template.props.repeaterKey[key].repeaterParentProps.repeat.__ob__.on('change:' + this.template.props.repeaterKey[key].repeaterProps.itemIndex, this.onPathChange);
                                }
                            }
                        }

                        if (this.template.props.repeaterIndex !== null) {
                            for (var _key in this.template.props.repeaterIndex) {
                                if (this.stringParts[i].value.pathRoots[j] === _key && this.template.props.repeaterIndex[_key].repeaterParentProps.repeat !== null) {
                                    isBinded = true;
                                    this.template.props.__ob__.on('subChange:itemIndex', this.onPathChange);
                                    this.template.props.__ob__.on('change:itemIndex', this.onPathChange);
                                }
                            }
                        }

                        if (!isBinded) {
                            this.template._scope.__ob__.on('subChange:' + this.stringParts[i].value.pathRoots[j], this.onPathChange);
                            this.template._scope.__ob__.on('change:' + this.stringParts[i].value.pathRoots[j], this.onPathChange);
                        }
                    }
                }
            }
        };

        $Watcher.prototype.parseExpression = function parseExpression() {
            var _this = this;

            //all mustaches founds
            var charIndex = 0;

            this.content.replace(/\{\{[^{}]*\}\}/g, function (match, offset, string) {

                var str = _this.content.slice(charIndex, offset);

                if (str != "") {
                    _this.stringParts.push({
                        type: 'string',
                        value: _this.content.slice(charIndex, offset)
                    });
                }

                charIndex = offset + match.length;

                var expression = match.replace(/(\{\{|\}\})/g, '');

                if (/\sin\s/g.test(expression)) {
                    expression = expression.replace(/(?:(\S+)\s?\,)?\s?(\S*)\s+in\s+/g, function (match, index, key) {

                        _this.node._repeaterKey = key;

                        if (index !== void 0) {
                            _this.node._repeaterIndex = index;
                        }

                        return "";
                    });
                }

                _this.stringParts.push({
                    type: 'expression',
                    expression: expression,
                    value: _this._makeGetterFn(expression)
                });
            });

            //push the rest of the string
            if (charIndex < this.content.length && !/^\s+$/g.test(this.content.slice(charIndex))) {
                this.stringParts.push({
                    type: 'string',
                    value: this.content.slice(charIndex)
                });
            }

            this.numStringParts = this.stringParts.length;
        };

        $Watcher.prototype._makeGetterFn = function _makeGetterFn(expression) {
            var _this2 = this;

            var pathRoots = [];

            var body = expression.replace(/((?:\.[A-Za-z_$][a-zA-Z0-9\_\$]*)|(?:['][^']*[']|["][^"]*["]))|([A-Za-z_$][a-zA-Z0-9\_\$]*)/g, function (match, $1, $2, index) {

                if (allowedKeywordsRE.test($2)) {
                    return match;
                }

                pathRoots.push($2);

                if ($2 === '$index') {
                    return 'this.props.itemIndex';
                }

                if ($2 === '$value') {
                    return '(this._item && this._item[this.props.itemIndex] ? this._item[this.props.itemIndex] : {})';
                }

                if ($2 === '$length') {
                    return 'this.props.itemLength';
                }

                if (_this2.template.props.repeaterKey !== null && $2 in _this2.template.props.repeaterKey) {
                    return '(this.props.repeaterKey["' + $2 + '"].repeaterParentProps.repeat[this.props.repeaterKey["' + $2 + '"].repeaterProps.itemIndex] !== void 0 ? this.props.repeaterKey["' + $2 + '"].repeaterParentProps.repeat[this.props.repeaterKey["' + $2 + '"].repeaterProps.itemIndex] : {})';
                }

                if (_this2.template.props.repeaterIndex !== null && $2 in _this2.template.props.repeaterIndex) {
                    return '(this.props.repeaterIndex["' + $2 + '"].repeaterProps.itemIndex !== void 0 ? this.props.repeaterIndex["' + $2 + '"].repeaterProps.itemIndex : 0)';
                }

                return $2 !== void 0 ? 'this._scope.' + $2 : match;
            });

            try {
                return {
                    fn: new Function([], 'return ' + body + ';'),
                    pathRoots: pathRoots
                };
            } catch (e) {

                utils.warn('Invalid expression. ' + 'Generated function body: ' + repeaterKey + '\n' + body);

                return {
                    fn: function getterFn() {},
                    pathRoots: pathRoots
                };
            }
        };

        $Watcher.prototype.disable = function disable() {
            this.enabled = false;
        };

        $Watcher.prototype.enable = function enable() {
            this.enabled = true;

            //update binding if something happened while the watcher was disbaled
            if (this._needsUpdate) {
                this._needsUpdate = false;
                this.onPathChange();
            }
        };

        $Watcher.prototype.destroy = function destroy() {

            if (this.oldNode) {
                this.oldNode.removeEventListener('DOMNodeInserted', this._onDOMNodeInserted);
            }

            for (var i = 0, l = this.numStringParts; i < l; i++) {

                if (this.stringParts[i].type === "expression") {

                    for (var j = 0, _l2 = this.stringParts[i].value.pathRoots.length; j < _l2; j++) {

                        var isBinded = false;

                        if (this.template._item !== null && this.stringParts[i].value.pathRoots[j] === '$value') {
                            isBinded = true;
                            this.template._item.__ob__.off('subChange:' + this.template.props.itemIndex, this.onPathChange);
                            this.template._item.__ob__.off('change:' + this.template.props.itemIndex, this.onPathChange);
                        }

                        if (this.template.props.repeaterKey !== null) {
                            for (var key in this.template.props.repeaterKey) {
                                if (this.stringParts[i].value.pathRoots[j] === key && this.template.props.repeaterKey[key].repeaterParentProps.repeat !== null) {
                                    isBinded = true;
                                    this.template.props.repeaterKey[key].repeaterParentProps.repeat.__ob__.off('subChange:' + this.template.props.repeaterKey[key].repeaterProps.itemIndex, this.onPathChange);
                                    this.template.props.repeaterKey[key].repeaterParentProps.repeat.__ob__.off('change:' + this.template.props.repeaterKey[key].repeaterProps.itemIndex, this.onPathChange);
                                }
                            }
                        }

                        if (this.template.props.repeaterIndex !== null) {
                            for (var _key2 in this.template.props.repeaterIndex) {
                                if (this.stringParts[i].value.pathRoots[j] === _key2 && this.template.props.repeaterIndex[_key2].repeaterParentProps.repeat !== null) {
                                    isBinded = true;
                                    this.template.props.__ob__.off('subChange:itemIndex', this.onPathChange);
                                    this.template.props.__ob__.off('change:itemIndex', this.onPathChange);
                                }
                            }
                        }

                        if (!isBinded) {
                            this.template._scope.__ob__.off('subChange:' + this.stringParts[i].value.pathRoots[j], this.onPathChange);
                            this.template._scope.__ob__.off('change:' + this.stringParts[i].value.pathRoots[j], this.onPathChange);
                        }
                    }
                }
            }
        };

        /**
         * we use try/catch not to trigger error if the expression try to access an unknow prop on the scope
         * TODO: it may be better to rewrite path to remove those try/catch:
         * foo.bar[3] ---> (foo && foo.bar && foo.bar[3])
         */


        $Watcher.prototype.safeExecuteGetterFn = function safeExecuteGetterFn(fnIndex, scope, itemIndex, itemLength, item) {
            try {
                return this.stringParts[fnIndex].value.fn.call(this.template);
            } catch (e) {
                return;
            }
        };

        $Watcher.prototype.onPathChange = function onPathChange() {

            //perf boost, if template and/or node is disabled
            if (this.enabled === false || this.node.visible !== void 0 && this.node.visible === false) {
                this._needsUpdate = true;
                return;
            }

            //POLYFILL IS ATTRIBUTE
            if (this.attrName === "is") {

                var tagName = false;

                //try {
                //    tagName = this.stringParts[0].value.fn( this.template._scope, this.template.props.itemIndex, this.template.props.itemLength, this.template._item !== null ? this.template._item[this.template.props.itemIndex] : '' );
                //} catch (e) {}
                tagName = this.safeExecuteGetterFn(0);

                if (tagName && tagName !== this.node.tagName.toLowerCase()) {

                    var elmnt = document.createElement(tagName);

                    //we duplicate all attributes from the old node to the new node
                    for (var _i = 0, l = this.node.attributes.length; _i < l; _i++) {
                        if (this.node.attributes[_i].nodeName !== 'is') {
                            elmnt.setAttribute(this.node.attributes[_i].nodeName, this.node.attributes[_i].nodeValue);
                        }
                    }

                    if (this.node.hasAttribute('root-node')) {
                        var nodeIndex = Number(this.node.getAttribute('root-node'));
                        elmnt.setAttribute('root-node', nodeIndex);
                        //replace the node in this.template._nodes to avoid memory leak
                        this.template._nodes[nodeIndex] = elmnt;
                    }

                    //check the new created node to add binding on it because in the previous check,
                    //the node ref was kept using closure, thus the new node is not available on previous binding.
                    //TODO: rcheck for eventual memory leak
                    this.template._preCheckNode(elmnt);

                    if (this.node.parentNode) {
                        if (this.node.nextSibling) {
                            this.node.parentNode.insertBefore(elmnt, this.node.nextSibling);
                        } else {
                            this.node.parentNode.appendChild(elmnt);
                        }
                    }

                    this.template._postCheckNode(elmnt);

                    //wait for the node to be inserted before checkijg content as it needs parentNode
                    this.template._checkContent(elmnt);

                    //first time the is attribute is polyfilled
                    if (this.lightDom.length === 0) {
                        for (var _i2 = 0; _i2 < this.node.childNodes.length; _i2++) {
                            this.lightDom.push(this.node.childNodes[_i2]);
                        }
                    }

                    //make sure  the eachnode loop is ended
                    //TODO: remove timer by chnaging the way the nodes are checked
                    //setTimeout(()=>{

                    for (var _i3 = 0; _i3 < this.lightDom.length; _i3++) {
                        elmnt.appendChild(this.lightDom[_i3]);
                    }

                    //replace node in closure
                    if (this.node.parentNode) {
                        this.node.parentNode.removeChild(this.node);
                    }

                    this.node = elmnt;

                    //},0);
                }
            } else if (!this.isTextNode && this.node._defaultProps !== void 0
                //&& this.node.props[this.formatedPropName] !== void 0
                 && this.node._defaultProps[this.formatedPropName] !== void 0) {

                    if (this.numStringParts === 1 && this.stringParts[0].type === "expression") {

                        //try {
                        //  newValue = this.stringParts[0].value.fn(this.template._scope, this.template.props.itemIndex, this.template.props.itemLength, this.template._item !== null ? this.template._item[this.template.props.itemIndex] : '');
                        //} catch (e) {}
                        this.newValue = this.safeExecuteGetterFn(0);
                    } else {

                        //TODO DRY
                        this.newValue = '';

                        for (var i = 0; i < this.numStringParts; i++) {
                            if (this.stringParts[i].type === "expression") {
                                var v = this.safeExecuteGetterFn(i);
                                this.newValue += typeof v === 'object' ? JSON.stringify(v) : v;
                            } else {
                                this.newValue += this.stringParts[i].value;
                            }
                        }
                    }

                    if (this.newValue !== void 0) {
                        this.node.setProp(this.formatedPropName, this.newValue);
                    }
                } else {

                    this.oldValue = this.newValue;

                    if (this.numStringParts === 1 && this.stringParts[0].type === "expression") {

                        this.newValue = this.safeExecuteGetterFn(0);

                        if (this.newValue !== null && typeof this.newValue === 'object') {
                            this.newValue = JSON.stringify(this.newValue);
                        }
                    } else {
                        //TODO DRY
                        this.newValue = '';
                        for (var i = 0; i < this.numStringParts; i++) {
                            if (this.stringParts[i].type === "expression") {
                                this.newValue += this.safeExecuteGetterFn(i);
                            } else {
                                this.newValue += this.stringParts[i].value;
                            }
                        }
                    }

                    if (!this.isTextNode) {

                        // if (this.lastValue === void 0) {
                        //     this.lastValue = this.node.getAttribute(this.attrName);
                        // }

                        // if (this.lastValue !== this.newValue.toString()) {
                        if (this.removableAttr && (this.newValue === "false" || !this.newValue)) {
                            this.node.removeAttribute(this.attrName);
                            this.node.removeAttribute(':' + this.attrName);
                        } else {

                            //for src and poster attributes don't trigger 404 if path is not resolved
                            if (this.attrName.charAt(0) == '$') {
                                this.node.removeAttribute(this.attrName);
                                this.attrName = this.attrName.replace('$', '');
                            }

                            if (this.attrName === 'set-class') {

                                if (this.oldValue !== void 0) {
                                    var oldClasses = this.oldValue.split(' ');

                                    for (var _i4 = 0, _l3 = oldClasses.length; _i4 < _l3; _i4++) {
                                        if (oldClasses[_i4].length) {
                                            this.node.classList.remove(oldClasses[_i4]);
                                        }
                                    }
                                }

                                var newClasses = this.newValue.split(' ');

                                for (var _i5 = 0, _l4 = newClasses.length; _i5 < _l4; _i5++) {
                                    if (newClasses[_i5].length) {
                                        this.node.classList.add(newClasses[_i5]);
                                    }
                                }
                            } else {

                                if (this.oldValue !== this.newValue) {
                                    this.node.setAttribute(this.attrName, this.newValue);
                                }
                            }
                            //this.lastValue = newValue.toString();
                        }
                        //}
                    } else {
                            if (this.node.innerHTML !== void 0) {
                                if (this.node.innerHTML !== this.newValue) {
                                    this.node.innerHTML = this.newValue;
                                }
                            } else {
                                //check for parentNode not to trigger error on IE9 when accessing textContent
                                //https://connect.microsoft.com/IE/feedbackdetail/view/944330/invalid-argument-error-when-changing-nodevalue-of-a-text-node-removed-by-setting-innerhtml-on-an-ancestor
                                if (this.node.parentNode !== void 0 && this.node.textContent !== this.newValue) {
                                    this.node.textContent = this.newValue;
                                }
                            }
                        }
                }
        };

        return $Watcher;
    }();

    //import 'TemplateComponentPolyfill';

    var UUID = 0;

    if (window.HTMLTemplateElement === void 0) {
        var contentDoc = document.implementation.createHTMLDocument('template');
        window.HTMLTemplateElement = function HTMLTemplateElement() {};
        window.HTMLTemplateElement.prototype = Object.create(HTMLElement.prototype);
    }

    var escapeDataRegExp = /[&\u00A0<>]/g;
    
    function escapeReplace(c) {
        switch (c) {
            case '&':
                return '&amp;';
            case '<':
                return '&lt;';
            case '>':
                return '&gt;';
            case ' ':
                return '&nbsp;';
        }
    }

    function escapeData(s) {
        return s.replace(escapeDataRegExp, escapeReplace);
    }

    var TemplateComponentPrototype = {

        onItemIndexChange: function () {
            this._scope.__ob__.fire('change:$index');
        },

        onItemLengthChange: function () {
            this._scope.__ob__.fire('change:$length');
        },

        onRepeaterKeyChange: function () {
            this._scope.__ob__.fire('change:$value');
            for (var key in this.props.repeaterKey) {
                this.props.repeaterKey[key].repeaterParentProps.repeat.__ob__.fire('subChange:' + this.props.repeaterKey[key].repeaterProps.itemIndex);
                this.props.repeaterKey[key].repeaterParentProps.repeat.__ob__.fire('change:' + this.props.repeaterKey[key].repeaterProps.itemIndex);
            }
        },

        onRepeaterIndexChange: function () {
            this._scope.__ob__.fire('change:$index');
        },

        detached: function () {

            if (this._nodes && this._nodes.length > 0) {
                while (this._nodes[0]) {
                    // TODO: for <slot> parentNode is null
                    if (this._nodes[0].parentNode != null) {
                        this._nodes[0].parentNode.removeChild(this._nodes[0]);
                    }
                    this._nodes.splice(0, 1);
                }
            }

            if (this._templateNodes && this._templateNodes.length > 0) {
                while (this._templateNodes[0]) {
                    if (this._templateNodes[0].parentNode !== null && this._templateNodes[0].parentNode !== void 0) {
                        this._templateNodes[0].parentNode.removeChild(this._templateNodes[0]);
                    }
                    this._templateNodes.splice(0, 1);
                }
            }

            if (this._watchers !== void 0) {
                for (var i = 0; i < this._watchers.length; i++) {
                    this._watchers[i].destroy();
                }
            }

            this._watchers = [];
        },

        _retrieveLightDom: function () {},

        _retrieveTemplate: function () {},

        created: function () {

            this._uuid = UUID++;

            if (this.content === void 0) {
                this.content = document.createDocumentFragment();
                this.isPolyfilled = true;
            }

            this._rootNode = this;
            this._isCreated = true;
            this._nodes = [];
            this._originPreviousSibling = null; //used for dom injection by template
            this._originNextSibling = null; //used for dom injection by template
            this._item = null;

            this._repeaterKey = null;
            this._repeaterIndex = null;

            this._scope = null;

            //keep reference of observers callback to remove it on destroy
            this._watchers = [];

            //sub templates created  by a template repeater
            this._templateNodes = [];

            this._templateNodeReady = 0; //to implement

            Object.defineProperty(this, 'innerHTML', {
                get: function getInnerHTML() {
                    var o = '';

                    for (var e = this.content.firstChild; e; e = e.nextSibling) {
                        o += e.outerHTML || escapeData(e.data);
                    }

                    return o;
                },
                set: function setInnerHTML(text) {
                    while (this.content.firstChild) {
                        this.content.removeChild(this.content.firstChild);
                    }

                    var div = document.createElement('div');
                    this.content.appendChild(div);
                    div.innerHTML = text;

                    while (div.hasChildNodes()) {
                        this.content.appendChild(div.childNodes[0]);
                    }

                    this.content.removeChild(div);
                },
                configurable: true
            });
        },

        appendChild: function (node) {
            this.content.appendChild(node);
        },

        insertBefore: function (node, beforeNode) {
            this.content.appendChild(node, beforeNode);
        },

        removeChild: function (node) {
            this.content.removeChild(node);
        },

        ready: function () {
            // console.log( 'ready()', this );
        },

        /**
        * we use the ready callback to make sure
        * the template props has been hydrated by the parent template
        *
        * By default the if attribute is set to true, then it can be overrident by the parent template using data-binding
        * but this may occur after the attached callback. Thus, using ready, we are sure the checNode from parent scope has been called
        * and the current value of IF is the desired one
        *
        */

        attached: function () {

            if (!this._originNextSibling) {
                this._originNextSibling = this.nextSibling;
            }

            if (!this._originPreviousSibling) {
                this._originPreviousSibling = this.previousSibling;
            }

            this._isAttached = true;

            //if not native template, move the childNodes to the content documentFragment
            if (this.isPolyfilled) {
                while (this.hasChildNodes()) {
                    this.content.appendChild(this.childNodes[0]);
                }
            }

            this.hasRepeatAttr = this.hasAttribute('repeat') || this.hasAttribute('data-repeat');

            if (this.props.if !== null) {
                if (this.hasRepeatAttr) {
                    this.onRepeatChange();
                } else {
                    this.onIfChange();
                }
            }
        },

        _passContext: function (node) {
            if (node.tagName && node.context !== void 0) {
                node.context = this.context;
            }
        },

        //read the template.content and add cloned nodes
        //to this component parentNode
        _scopeNode: function (node) {

            if (node.tagName && node.tagName === "TEMPLATE" && node.getAttribute('shadow-dom') === null) {

                //don't continue parsing childNodes as in LIGHT-CORE-TEMPLATE, childNodes shouldn't exist
                //all content is moved to its documentFragment (node.content == #documentFragment)
                //documentFragment helps emulate native template behaviour
                node._scope = this._scope;
                node._componentContext = this._componentContext;

                //if the <slot> tag is inside a sub template, this template loose the reference.
                //so it passes the content key to delegate the work to the subtemplate
                node._$slot = this._$slot;
                node._slotuuid = this._slotuuid;

                //if in a repeater template, we need to pass down the 'item' and 'itemIndex' key
                //way pass the parent so that a sub sub sub template can access the $index key by using $.parent or something like that

                if (this._item !== null) {
                    if (node.props) {
                        node._item = this._item;
                        node.props.itemIndex = this.props.itemIndex;
                        node.props.itemLength = this.props.itemLength;
                        node.props.repeaterKey = {};
                        node.props.repeaterIndex = {};
                        for (var k in this.props.repeaterKey) {
                            node.props.repeaterKey[k] = this.props.repeaterKey[k];
                        }
                        for (var _k in this.props.repeaterIndex) {

                            node.props.repeaterIndex[_k] = this.props.repeaterIndex[_k];
                        }
                    }
                }
            }

            // We pass the template referer to the node to emulate shadowDom behaviour
            node._$parentUUID = this._uuid;
        },

        _addNodesToDom: function () {

            /**
             * debug
             */
            this._isAddingNodes = true;

            var nextSibling = this._rootNode.nextSibling;

            for (var i = 0; i < this.content.childNodes.length; i++) {

                //8 == comment node
                if (this.content.childNodes[i].nodeType != 8) {

                    //var node = this.content.childNodes[i].cloneNode(true);
                    var node = document.importNode(this.content.childNodes[i], true);

                    // a bug in registerlement polyfill will not call the created callback, but will wait for the node to be added to the DOM.
                    // Thus we cannot hydrtae props before attaching the node to DOM to we get a Flash of unhydrated content(FOUC)

                    this._nodes[i] = node;

                    if (node.nodeType == 1) {
                        node.setAttribute('root-node', i);
                    }

                    this._preCheckNode(this._nodes[i]);

                    //TODO: check why parent may not exists
                    if (this.parentNode) {
                        if (nextSibling) {
                            this.parentNode.insertBefore(this._nodes[i], nextSibling);
                        } else {
                            this.parentNode.appendChild(this._nodes[i]);
                        }
                        this._rootNode = this._nodes[i];
                    }

                    this._postCheckNode(this._nodes[i]);

                    this._checkContent(this._nodes[i]);
                }
            }

            //this.fire('templateready', this.index );

            this._ready();
            this._isTemplateReady = true;
        },

        _preCheckNode: function (node, is_RootNode, index) {
            var _this = this;

            this._eachNodes(node, function (subNode) {
                if (subNode.nodeType != 8) {
                    //inject scope if it's a template
                    //or inject _componentContext if it's a component node
                    _this._scopeNode(subNode);

                    //pass _componentContext.context to subComponents
                    _this._passContext(subNode);

                    //set props and binding: TODO: may check if possible to ready attribute of node before attached
                    _this._checkBindingOnNode(subNode);
                }
            });
        },

        _postCheckNode: function (node, is_RootNode, index) {
            // this._eachNodes(node, (subNode) => {
            //     this._checkBindingOnNode(subNode);
            // });
        },

        _checkContent: function (node) {
            var _this2 = this;

            /**
             * We inject <slot> after the _checkBindingOnNode loop not to parse the injected content as it
             * must be managed by a parent scope
             */
            //TODO find a way to stop eachNode method loop
            this._eachNodes(node, function (subNode) {
                if (subNode.nodeType != 8) {
                    if (subNode.tagName && (subNode.tagName.toLowerCase() === "content" || subNode.tagName.toLowerCase() === "slot")) {

                        // console.log('<content> found', subNode, this.parentNode, this.parentNode._isLightDom );

                        //console.log("REPLACE CONTENT", this,  this._$slot, subNode, subNode.parentNode );
                        subNode.parentNode.replaceChild(_this2._$slot, subNode);

                        /**
                         * Keep ref to content
                         */
                        // while (this._$slot.hasChildNodes()) {
                        //     subNode.appendChild(this._$slot.childNodes[0]);
                        // }
                        // this._$slot = subNode;
                        //
                    }
                }
            });
        },

        onRepeatChange: function ( /*oldVal, newVal, */infos) {

            //the $Obersver have to modify the array/object before triggering a notify event
            //so the repeat change is triggered twice: once for the original array modification, then once for the notification.
            //thus we use a timer to wait for the notification if it exists, or use the original repeatchange.
            // clearTimeout(this.repeatChangeTimer);
            // this.repeatChangeTimer = setTimeout(()=>{

            // console.log('ON_REPEAT_CHANGE',this, infos, this.props.repeat);

            if (this.props.if && this.props.repeat !== null) {

                if (typeof infos === "undefined" || infos === null) {
                    infos = {};
                    infos.index = 0;
                    infos.numRemoved = this._templateNodes.length;
                    infos.numAdded = this.props.repeat.length;
                }

                if (infos.numRemoved > 0) {

                    for (var i = infos.index; i < infos.index + infos.numRemoved; i++) {
                        // TODO: check why this._templateNodes[i] is undefined
                        if (this._templateNodes[i]) {

                            this._templateNodes[i].setAttribute('is-dead-node', '');
                            if (this._templateNodes[i].parentNode !== void 0 && this._templateNodes[i].parentNode !== null) {
                                this._templateNodes[i].parentNode.removeChild(this._templateNodes[i]);
                            }
                            this._templateNodes[i] = null;
                        }
                    }

                    this._templateNodes.splice(infos.index, infos.numRemoved);
                }

                for (var _i = 0; _i < this._templateNodes.length; _i++) {

                    this._templateNodes[_i].props.itemIndex = _i;
                    this._templateNodes[_i].props.itemLength = this.props.repeat.length;
                    // this._templateNodes[i].props.repeaterKey    = this.props.repeaterKey;
                    // this._templateNodes[i].props.repeaterIndex  = this.props.repeaterIndex;

                    this._templateNodes[_i].setAttribute('_repeater-index', _i);

                    if (this._repeaterKey !== null) {
                        for (var k in this.props.repeaterKey) {
                            this._templateNodes[_i].props.repeaterKey[k] = this.props.repeaterKey[k];
                        }
                        this._templateNodes[_i].props.repeaterKey[this._repeaterKey] = {
                            repeaterParentProps: this.props,
                            repeaterProps: this._templateNodes[_i].props
                        };
                    }

                    if (this._repeaterIndex !== null) {

                        for (var _k2 in this.props.repeaterIndex) {
                            this._templateNodes[_i].props.repeaterIndex[_k2] = this.props.repeaterIndex[_k2];
                        }

                        this._templateNodes[_i].props.repeaterIndex[this._repeaterIndex] = {
                            repeaterParentProps: this.props,
                            repeaterProps: this._templateNodes[_i].props
                        };
                    }
                }

                if (infos.numAdded > 0) {

                    var nextSibling;

                    if (this._templateNodes.length > 0) {
                        var lastRepeaterNode = this._templateNodes[this._templateNodes.length - 1];
                        if (lastRepeaterNode._nodes.length > 0) {
                            nextSibling = lastRepeaterNode._nodes[lastRepeaterNode._nodes.length - 1].nextSibling;
                        } else {
                            nextSibling = lastRepeaterNode.nextSibling;
                        }
                    } else {
                        nextSibling = this.nextSibling;
                    }

                    for (var _i2 = infos.index; _i2 < infos.index + infos.numAdded; _i2++) {

                        var repeaterNode = document.createElement('template', 'light-core-template');
                        repeaterNode.setAttribute('_repeater-index', _i2);

                        for (var j = 0; j < this.content.childNodes.length; j++) {
                            repeaterNode.content.appendChild(this.content.childNodes[j].cloneNode(true));
                        }

                        repeaterNode._scope = this._scope;
                        repeaterNode._componentContext = this._componentContext;
                        repeaterNode._$slot = this._$slot;
                        repeaterNode._slotuuid = this._slotuuid;
                        repeaterNode.props.itemIndex = _i2;
                        repeaterNode.props.itemLength = this.props.repeat.length;
                        repeaterNode.props.repeaterKey = {};
                        repeaterNode.props.repeaterIndex = {};

                        if (typeof this.props.repeat === 'object') {
                            repeaterNode._item = this.props.repeat;
                        }

                        if (this._repeaterKey !== null) {
                            for (var _k3 in this.props.repeaterKey) {
                                repeaterNode.props.repeaterKey[_k3] = this.props.repeaterKey[_k3];
                            }
                            repeaterNode.props.repeaterKey[this._repeaterKey] = {
                                repeaterParentProps: this.props,
                                repeaterProps: repeaterNode.props
                            };
                        }

                        if (this._repeaterIndex !== null) {
                            for (var _k4 in this.props.repeaterIndex) {
                                repeaterNode.props.repeaterIndex[_k4] = this.props.repeaterIndex[_k4];
                            }
                            repeaterNode.props.repeaterIndex[this._repeaterIndex] = {
                                repeaterParentProps: this.props,
                                repeaterProps: repeaterNode.props
                            };
                        }

                        this._templateNodes.push(repeaterNode);

                        if (this.parentNode !== void 0 && this.parentNode !== null) {
                            if (nextSibling) {
                                nextSibling.parentNode.insertBefore(repeaterNode, nextSibling);
                            } else {
                                this.parentNode.appendChild(repeaterNode);
                            }
                        }
                    }
                }
            } else {
                this.onIfChange();
            }

            // },0);
        },

        enable: function () {

            if (this.props.repeat) {
                var i = this._templateNodes.length;

                while (i--) {
                    this._templateNodes[i]._enable();
                }
            } else {

                var _i3 = this._nodes.length;

                while (_i3--) {
                    this._eachNodes(this._nodes[_i3], function (subNode) {

                        if (subNode._enable) {
                            subNode._enable();
                        } else {
                            subNode.visible = true;
                        }
                        if (subNode.nodeType == 1) {
                            //#textNode

                            if (subNode.classList) {
                                subNode.classList.remove('is-disabled');
                            } else {
                                var cur = ' ' + (subNode.getAttribute('class') || '') + ' ';
                                var tar = ' ' + 'is-disabled' + ' ';

                                while (cur.indexOf(tar) >= 0) {
                                    cur = cur.replace(tar, ' ');
                                }

                                subNode.setAttribute('class', cur.trim());
                            }
                            subNode.removeAttribute('is-disabled');
                        }
                    });
                }

                for (var _i4 = 0; _i4 < this._watchers.length; _i4++) {
                    this._watchers[_i4].enable();
                }
            }
        },

        disable: function () {

            for (var i = 0; i < this._watchers.length; i++) {
                this._watchers[i].disable();
            }

            if (this.props) {
                if (this.props.repeat) {
                    var _i5 = this._templateNodes.length;

                    while (_i5--) {
                        this._templateNodes[_i5]._disable();
                    }
                } else {
                    var _i6 = this._nodes.length;

                    while (_i6--) {

                        this._eachNodes(this._nodes[_i6], function (subNode) {

                            if (subNode._disable) {
                                subNode._disable();
                            } else {
                                subNode.visible = false;
                            }
                            if (subNode.nodeType == 1) {
                                //#textNode
                                if (subNode.classList) {
                                    subNode.classList.add('is-disabled');
                                } else {
                                    var cur = ' ' + (subNode.getAttribute('class') || '') + ' ';

                                    if (cur.indexOf(' ' + 'is-disabled' + ' ') < 0) {
                                        subNode.setAttribute('class', (cur + 'is-disabled').trim());
                                    }
                                }
                                subNode.setAttribute('is-disabled', '');
                            }
                        });
                    }
                }
            }
        },

        onIfChange: function () {

            if (this.props.if) {
                if (this.hasRepeatAttr) {
                    if (this.props.repeat) {
                        this.onRepeatChange();
                    }
                } else {
                    if (this._nodes.length === 0) {
                        this._addNodesToDom();
                    } else {
                        this.enable();
                    }
                }
            } else {
                if (this.props.removeNodes === true) {

                    for (var i = 0; i < this._watchers.length; i++) {
                        this._watchers[i].destroy();
                    }
                    this._watchers = [];

                    for (var _i7 = 0; _i7 < this._nodes.length; _i7++) {
                        if (this._nodes[_i7] !== void 0 && this._nodes[_i7].parentNode) {
                            this._nodes[_i7].parentNode.removeChild(this._nodes[_i7]);
                        }
                    }
                    this._nodes = [];
                } else {
                    this.disable();
                }
            }
        },

        onBindChange: function () {},

        _checkBindingOnNode: function (node) {

            if (node.attributes) {

                var attributes = [];

                if (node.getAttribute("is") !== void 0 && /\{\{[^{}]*\}\}/g.test(node.getAttribute("is"))) {
                    attributes.push({
                        nodeName: "is",
                        nodeValue: node.getAttribute("is")
                    });
                } else {
                    //in IE, a bug breaks the attribute loop,
                    //so we first push all attributes to an array, then we loop on it
                    for (var i = 0, l = node.attributes.length; i < l; i++) {
                        attributes.push({
                            nodeName: node.attributes[i].nodeName,
                            nodeValue: node.attributes[i].nodeValue
                        });
                    }
                }

                for (var _i8 = 0, _l = attributes.length; _i8 < _l; _i8++) {

                    var attrName = attributes[_i8].nodeName;
                    var attrValue = attributes[_i8].nodeValue;

                    var formatedPropName = utils.camelCalise(attrName.replace("data-", ""));

                    if (/^on/.test(formatedPropName)) {

                        var eventName = formatedPropName.replace('on', '').toLowerCase();

                        if (nativeEvents.indexOf(eventName) !== -1) {

                            if (this._componentContext && this._componentContext[attrValue] !== void 0) {
                                this._componentContext._registerEvent(eventName, node, attrValue);
                            }
                        } else {
                            this._checkCallbackOnAttribute(node, attrName, attrValue);
                        }
                    } else {
                        this._addBinding(node, attrName, attrValue);
                    }
                }
            } else {
                //the node is a text node
                //check for parentNode because on IE9, if parentNode is undefined, the node enters a broken state that would trigger error if we try to access the textContent property
                if (node.parentNode !== void 0 && node.textContent) {
                    this._addBinding(node);
                }
            }
        },

        _checkCallbackOnAttribute: function (node, attrName, attrValue) {

            var formatedPropName = utils.camelCalise(attrName.replace("data-", "")).replace(/\s/g, '');

            if (this._componentContext && this._componentContext[attrValue] !== void 0 && node.props && node.props[formatedPropName] !== void 0) {
                node.props[formatedPropName] = this._componentContext[attrValue].bind(this._componentContext);
            }
        },

        _addBinding: function (node, attrName, attrValue) {
            var content = node.attributes ? attrValue : node.parentNode !== void 0 ? node.textContent : '';
            if (/\{\{[^{}]*\}\}/g.test(content)) {
                this._watchers.push(new $Watcher(node, attrName, content, this));
            }
        },

        //assign defualtProps on prototype not to duplicate it on each instance
        _defaultProps: {
            if: {
                type: 'bool',
                value: true,
                change: 'onIfChange'
            },
            repeat: {
                type: "json",
                value: null,
                change: 'onRepeatChange'
            },
            bind: {
                type: 'json',
                value: null,
                change: 'onBindChange'
            },
            itemIndex: {
                type: 'int',
                value: null,
                change: 'onItemIndexChange'
            },
            itemLength: {
                type: 'int',
                value: null,
                change: 'onItemLengthChange'
            },
            repeaterKey: {
                type: 'json',
                value: null,
                change: 'onRepeaterKeyChange'
            },
            repeaterIndex: {
                type: 'json',
                value: null,
                change: 'onRepeaterIndexChange'
            },
            removeNodes: {
                type: 'bool',
                value: false
            }
        }

    };

    var _HTMLTemplateElement;
    if (typeof HTMLElement !== 'function') {
        _HTMLTemplateElement = function () {};
        _HTMLTemplateElement.prototype = document.createElement('template');
    } else {
        _HTMLTemplateElement = HTMLTemplateElement;
    }

    var LightCoretemplate = function (_HTMLTemplateElement2) {
        babelHelpers.inherits(LightCoretemplate, _HTMLTemplateElement2);

        function LightCoretemplate() {
            babelHelpers.classCallCheck(this, LightCoretemplate);
            return babelHelpers.possibleConstructorReturn(this, _HTMLTemplateElement2.apply(this, arguments));
        }

        return LightCoretemplate;
    }(_HTMLTemplateElement);

    for (var k$2 in TemplateComponentPrototype) {
        LightCoretemplate.prototype[k$2] = TemplateComponentPrototype[k$2];
    }
    for (var _k5 in ComponentMixin) {
        LightCoretemplate.prototype[_k5] = ComponentMixin[_k5];
    }
    for (var _k6 in EventDispatcherMixin) {
        LightCoretemplate.prototype[_k6] = EventDispatcherMixin[_k6];
    }
    register('light-core-template', LightCoretemplate, 'template');

    var _HTMLElement$1;
    if (typeof HTMLElement !== 'function') {
        _HTMLElement$1 = function () {};
        _HTMLElement$1.prototype = document.createElement('div');
    } else {
        _HTMLElement$1 = HTMLTemplateElement;
    }

    var LightTemplate = function (_HTMLElement2) {
        babelHelpers.inherits(LightTemplate, _HTMLElement2);

        function LightTemplate() {
            babelHelpers.classCallCheck(this, LightTemplate);
            return babelHelpers.possibleConstructorReturn(this, _HTMLElement2.apply(this, arguments));
        }

        return LightTemplate;
    }(_HTMLElement$1);

    for (var _k7 in TemplateComponentPrototype) {
        LightTemplate.prototype[_k7] = TemplateComponentPrototype[_k7];
    }
    for (var _k8 in ComponentMixin) {
        LightTemplate.prototype[_k8] = ComponentMixin[_k8];
    }
    for (var _k9 in EventDispatcherMixin) {
        LightTemplate.prototype[_k9] = EventDispatcherMixin[_k9];
    }
    register('light-template', LightTemplate);

    var light = {
    	Component: Component,
    	components: components,
    	register: register,
    	StateProvider: StateProvider,
    	//$xhr: $xhr,
    	EventDispatcher: EventDispatcher,
    	utils: utils,
    	support: support$1,
    	TemplateComponent: LightCoretemplate,
    	EventDispatcherMixin: EventDispatcherMixin,
    	ComponentMixin: ComponentMixin
    };

    var resizeEndTimer;

    function onResize() {
    	clearTimeout(resizeEndTimer);
    	EventDispatcher.fire('resize');
    	resizeEndTimer = setTimeout(function () {
    		EventDispatcher.fire('resizeend');
    	}, 300);
    }

    //main render loop
    function renderLoop() {
    	requestAnimationFrame(renderLoop);
    	EventDispatcher.fire('requestAnimationFrame');
    }

    window.addEventListener('resize', onResize, false);

    onResize();

    requestAnimationFrame(renderLoop);

    // var infos = require('../package.json');
    // if (window.console !== void 0) {
    // 	window.console[window.console.debug === void 0 ? 'log':'debug' ]("Light.js v"+infos.version);
    // }
    window.console[window.console.debug === void 0 ? 'log' : 'debug']("Light.js v107");

    return light;

}));
//# sourceMappingURL=light.js.map